import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_wildsky_common_proto from './dcei_wildsky_common_proto';
class PromotionBundleConfig_Filter_DateFilter {
  get descriptor() {
    return PromotionBundleConfig_Filter_DateFilter.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasStartTime = false;
    this._startTime = null;
    this._hasEndTime = false;
    this._endTime = null;
  }
  isEmpty() {
    if (this._hasStartTime) return false;
    if (this._hasEndTime) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PromotionBundleConfig_Filter_DateFilter) {
      return value;
    }
    return PromotionBundleConfig_Filter_DateFilter.fromJson(value);
  }
  static fromJson(json) {
    const result = new PromotionBundleConfig_Filter_DateFilter();
    if (json.startTime != null) {
      result._hasStartTime = true;
      result._startTime = JsonToInt32.fromJson(json.startTime);
    }
    if (json.endTime != null) {
      result._hasEndTime = true;
      result._endTime = JsonToInt32.fromJson(json.endTime);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasStartTime) {
      result.startTime = JsonToInt32.toJson(this._startTime);
    }
    if (this._hasEndTime) {
      result.endTime = JsonToInt32.toJson(this._endTime);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get startTime() {
    return this._hasStartTime ? this._startTime : JsonToInt32.default;
  }
  get hasStartTime() {
    return this._hasStartTime;
  }
  setStartTime(path, value) {
    return {type: 'SET', path: path.concat(['startTime']), value};
  }
  deleteStartTime(path) {
    return {type: 'DELETE', path: path.concat(['startTime'])};
  }
  /**
   * @returns {number}
   */
  get endTime() {
    return this._hasEndTime ? this._endTime : JsonToInt32.default;
  }
  get hasEndTime() {
    return this._hasEndTime;
  }
  setEndTime(path, value) {
    return {type: 'SET', path: path.concat(['endTime']), value};
  }
  deleteEndTime(path) {
    return {type: 'DELETE', path: path.concat(['endTime'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "startTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfig_Filter_DateFilter(this);
              copy._hasStartTime = true;
              copy._startTime = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStartTime) {
                return this;
              }
              const copy = new PromotionBundleConfig_Filter_DateFilter(this);
              copy._hasStartTime = false;
              copy._startTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "endTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfig_Filter_DateFilter(this);
              copy._hasEndTime = true;
              copy._endTime = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEndTime) {
                return this;
              }
              const copy = new PromotionBundleConfig_Filter_DateFilter(this);
              copy._hasEndTime = false;
              copy._endTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PromotionBundleConfig_Filter_DateFilter} other
   * @returns {PromotionBundleConfig_Filter_DateFilter}
   */
  merge(other) {
    const copy = new PromotionBundleConfig_Filter_DateFilter(this);
    if (other._hasStartTime) {
      copy._hasStartTime = true;
      copy._startTime = other._startTime;
    }
    if (other._hasEndTime) {
      copy._hasEndTime = true;
      copy._endTime = other._endTime;
    }
    return copy;
  }
}
PromotionBundleConfig_Filter_DateFilter.default = new PromotionBundleConfig_Filter_DateFilter();
class PromotionBundleConfig_Filter_DateFilter_Builder {
  constructor(value) {
    this._value = new PromotionBundleConfig_Filter_DateFilter(value);
  }
  build() {
    return new PromotionBundleConfig_Filter_DateFilter(this._value);
  }
  setStartTime(value) {
    this._value._hasStartTime = true;
    this._value._startTime = value;
    return this;
  }
  deleteStartTime() {
    this._value._hasStartTime = false;
    this._value._startTime = null;
    return this;
  }
  setEndTime(value) {
    this._value._hasEndTime = true;
    this._value._endTime = value;
    return this;
  }
  deleteEndTime() {
    this._value._hasEndTime = false;
    this._value._endTime = null;
    return this;
  }
}
PromotionBundleConfig_Filter_DateFilter.Builder = PromotionBundleConfig_Filter_DateFilter_Builder;
class PromotionBundleConfig_Filter_DateFilter_WithParent {
  /**
   * @param {PromotionBundleConfig_Filter_DateFilter} value
   * @param {PromotionBundleConfig_Filter_DateFilter_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PromotionBundleConfig_Filter_DateFilter.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasStartTime() {
    if (this._cachedHasStartTime === undefined) {
      if (this._value.hasStartTime) {
        this._cachedHasStartTime = true;
      } else {
        this._cachedHasStartTime = this._parent ? this._parent.hasStartTime : false;
      }
    }
    return this._cachedHasStartTime;
  }
  get startTime() {
    if (this._cachedStartTime === undefined) {
      if (this._value.hasStartTime) {
        this._cachedStartTime = this._value.startTime;
      } else {
        this._cachedStartTime = this._parent ? this._parent.startTime : this._value.startTime;
      }
    }
    return this._cachedStartTime;
  }
  get hasEndTime() {
    if (this._cachedHasEndTime === undefined) {
      if (this._value.hasEndTime) {
        this._cachedHasEndTime = true;
      } else {
        this._cachedHasEndTime = this._parent ? this._parent.hasEndTime : false;
      }
    }
    return this._cachedHasEndTime;
  }
  get endTime() {
    if (this._cachedEndTime === undefined) {
      if (this._value.hasEndTime) {
        this._cachedEndTime = this._value.endTime;
      } else {
        this._cachedEndTime = this._parent ? this._parent.endTime : this._value.endTime;
      }
    }
    return this._cachedEndTime;
  }
  update(current, parent) {
    const result = new PromotionBundleConfig_Filter_DateFilter_WithParent(current, parent);
    return result;
  }
}
PromotionBundleConfig_Filter_DateFilter_WithParent.default = new PromotionBundleConfig_Filter_DateFilter_WithParent(PromotionBundleConfig_Filter_DateFilter.default, null);
PromotionBundleConfig_Filter_DateFilter.WithParent = PromotionBundleConfig_Filter_DateFilter_WithParent;
class PromotionBundleConfig_Filter_DateFilter_Descriptor {
  get startTime() {
    if (!this._startTime) {
      this._startTime = {
        name: "startTime",
        Name: "StartTime",
        number: 1,
        protoType: 5,
        protoName: "start_time",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._startTime;
  }
  get endTime() {
    if (!this._endTime) {
      this._endTime = {
        name: "endTime",
        Name: "EndTime",
        number: 2,
        protoType: 5,
        protoName: "end_time",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._endTime;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.startTime,
        this.endTime,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForStartTime",
        Name: "DummyOneofForStartTime",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEndTime",
        Name: "DummyOneofForEndTime",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
PromotionBundleConfig_Filter_DateFilter.descriptor = new PromotionBundleConfig_Filter_DateFilter_Descriptor();
class PromotionBundleConfig_Filter_DailyProgressFilter {
  get descriptor() {
    return PromotionBundleConfig_Filter_DailyProgressFilter.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDailyTrialProgress = false;
    this._dailyTrialProgress = null;
  }
  isEmpty() {
    if (this._hasDailyTrialProgress && !this._dailyTrialProgress.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PromotionBundleConfig_Filter_DailyProgressFilter) {
      return value;
    }
    return PromotionBundleConfig_Filter_DailyProgressFilter.fromJson(value);
  }
  static fromJson(json) {
    const result = new PromotionBundleConfig_Filter_DailyProgressFilter();
    if (json.dailyTrialProgress != null) {
      result._hasDailyTrialProgress = true;
      result._dailyTrialProgress = dcei_wildsky_common_proto.IntRange.fromJson(json.dailyTrialProgress);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDailyTrialProgress && !this._dailyTrialProgress.isEmpty()) {
      result.dailyTrialProgress = dcei_wildsky_common_proto.IntRange.toJson(this._dailyTrialProgress);
    }
    return result;
  }
  /**
   * @returns {dcei_wildsky_common_proto.IntRange}
   */
  get dailyTrialProgress() {
    return this._hasDailyTrialProgress ? this._dailyTrialProgress : dcei_wildsky_common_proto.IntRange.default;
  }
  get hasDailyTrialProgress() {
    return this._hasDailyTrialProgress;
  }
  setDailyTrialProgress(path, value) {
    return {type: 'SET', path: path.concat(['dailyTrialProgress']), value: value.toJson()};
  }
  deleteDailyTrialProgress(path) {
    return {type: 'DELETE', path: path.concat(['dailyTrialProgress'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "dailyTrialProgress": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfig_Filter_DailyProgressFilter(this);
              copy._hasDailyTrialProgress = true;
              copy._dailyTrialProgress = dcei_wildsky_common_proto.IntRange.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDailyTrialProgress) {
                return this;
              }
              const copy = new PromotionBundleConfig_Filter_DailyProgressFilter(this);
              copy._hasDailyTrialProgress = false;
              copy._dailyTrialProgress = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasDailyTrialProgress) {
            const copy = new PromotionBundleConfig_Filter_DailyProgressFilter(this);
            copy._hasDailyTrialProgress = true;
            copy._dailyTrialProgress = dcei_wildsky_common_proto.IntRange.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._dailyTrialProgress.apply(type, path.slice(1), value);
          if (newValue === this._dailyTrialProgress) {
            return this;
          }
          const copy = new PromotionBundleConfig_Filter_DailyProgressFilter(this);
          copy._dailyTrialProgress = copy._dailyTrialProgress.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PromotionBundleConfig_Filter_DailyProgressFilter} other
   * @returns {PromotionBundleConfig_Filter_DailyProgressFilter}
   */
  merge(other) {
    const copy = new PromotionBundleConfig_Filter_DailyProgressFilter(this);
    if (other._hasDailyTrialProgress) {
      if (copy._hasDailyTrialProgress) {
        copy._dailyTrialProgress = copy.dailyTrialProgress.merge(other.dailyTrialProgress);
      } else {
        copy._dailyTrialProgress = other._dailyTrialProgress;
      }
      copy._hasDailyTrialProgress = true;
    }
    return copy;
  }
}
PromotionBundleConfig_Filter_DailyProgressFilter.default = new PromotionBundleConfig_Filter_DailyProgressFilter();
class PromotionBundleConfig_Filter_DailyProgressFilter_Builder {
  constructor(value) {
    this._value = new PromotionBundleConfig_Filter_DailyProgressFilter(value);
  }
  build() {
    return new PromotionBundleConfig_Filter_DailyProgressFilter(this._value);
  }
  setDailyTrialProgress(value) {
    this._value._hasDailyTrialProgress = true;
    this._value._dailyTrialProgress = value;
    return this;
  }
  deleteDailyTrialProgress() {
    this._value._hasDailyTrialProgress = false;
    this._value._dailyTrialProgress = null;
    return this;
  }
}
PromotionBundleConfig_Filter_DailyProgressFilter.Builder = PromotionBundleConfig_Filter_DailyProgressFilter_Builder;
class PromotionBundleConfig_Filter_DailyProgressFilter_WithParent {
  /**
   * @param {PromotionBundleConfig_Filter_DailyProgressFilter} value
   * @param {PromotionBundleConfig_Filter_DailyProgressFilter_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PromotionBundleConfig_Filter_DailyProgressFilter.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDailyTrialProgress() {
    if (this._cachedHasDailyTrialProgress === undefined) {
      if (this._value.hasDailyTrialProgress) {
        this._cachedHasDailyTrialProgress = true;
      } else {
        this._cachedHasDailyTrialProgress = this._parent ? this._parent.hasDailyTrialProgress : false;
      }
    }
    return this._cachedHasDailyTrialProgress;
  }
  get dailyTrialProgress() {
    if (!this._cachedDailyTrialProgress) {
      if (this._value.hasDailyTrialProgress) {
        this._cachedDailyTrialProgress = new dcei_wildsky_common_proto.IntRange.WithParent(this._value.dailyTrialProgress, this._parent && this._parent.hasDailyTrialProgress ? this._parent.dailyTrialProgress : null);
      } else {
        this._cachedDailyTrialProgress = this._parent ? new dcei_wildsky_common_proto.IntRange.WithParent(dcei_wildsky_common_proto.IntRange.default, this._parent.dailyTrialProgress) : dcei_wildsky_common_proto.IntRange.WithParent.default;
      }
    }
    return this._cachedDailyTrialProgress;
  }
  update(current, parent) {
    const result = new PromotionBundleConfig_Filter_DailyProgressFilter_WithParent(current, parent);
    if (this._cachedDailyTrialProgress && this._value.hasDailyTrialProgress && current.hasDailyTrialProgress) {
      if (this._value.dailyTrialProgress === current.dailyTrialProgress && this._parent === parent) {
        result._cachedDailyTrialProgress = this._cachedDailyTrialProgress;
      } else {
        result._cachedDailyTrialProgress = this._cachedDailyTrialProgress.update(current.dailyTrialProgress, parent && parent.hasDailyTrialProgress ? parent.dailyTrialProgress : null);
      }
    }
    return result;
  }
}
PromotionBundleConfig_Filter_DailyProgressFilter_WithParent.default = new PromotionBundleConfig_Filter_DailyProgressFilter_WithParent(PromotionBundleConfig_Filter_DailyProgressFilter.default, null);
PromotionBundleConfig_Filter_DailyProgressFilter.WithParent = PromotionBundleConfig_Filter_DailyProgressFilter_WithParent;
class PromotionBundleConfig_Filter_DailyProgressFilter_Descriptor {
  get dailyTrialProgress() {
    if (!this._dailyTrialProgress) {
      this._dailyTrialProgress = {
        name: "dailyTrialProgress",
        Name: "DailyTrialProgress",
        number: 1,
        protoType: 11,
        protoName: "daily_trial_progress",
        type: dcei_wildsky_common_proto.IntRange,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dailyTrialProgress;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.dailyTrialProgress,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDailyTrialProgress",
        Name: "DummyOneofForDailyTrialProgress",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
PromotionBundleConfig_Filter_DailyProgressFilter.descriptor = new PromotionBundleConfig_Filter_DailyProgressFilter_Descriptor();
class PromotionBundleConfig_Filter_PlayerLevelFilter {
  get descriptor() {
    return PromotionBundleConfig_Filter_PlayerLevelFilter.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPlayerLevel = false;
    this._playerLevel = null;
  }
  isEmpty() {
    if (this._hasPlayerLevel && !this._playerLevel.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PromotionBundleConfig_Filter_PlayerLevelFilter) {
      return value;
    }
    return PromotionBundleConfig_Filter_PlayerLevelFilter.fromJson(value);
  }
  static fromJson(json) {
    const result = new PromotionBundleConfig_Filter_PlayerLevelFilter();
    if (json.playerLevel != null) {
      result._hasPlayerLevel = true;
      result._playerLevel = dcei_wildsky_common_proto.IntRange.fromJson(json.playerLevel);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPlayerLevel && !this._playerLevel.isEmpty()) {
      result.playerLevel = dcei_wildsky_common_proto.IntRange.toJson(this._playerLevel);
    }
    return result;
  }
  /**
   * @returns {dcei_wildsky_common_proto.IntRange}
   */
  get playerLevel() {
    return this._hasPlayerLevel ? this._playerLevel : dcei_wildsky_common_proto.IntRange.default;
  }
  get hasPlayerLevel() {
    return this._hasPlayerLevel;
  }
  setPlayerLevel(path, value) {
    return {type: 'SET', path: path.concat(['playerLevel']), value: value.toJson()};
  }
  deletePlayerLevel(path) {
    return {type: 'DELETE', path: path.concat(['playerLevel'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "playerLevel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfig_Filter_PlayerLevelFilter(this);
              copy._hasPlayerLevel = true;
              copy._playerLevel = dcei_wildsky_common_proto.IntRange.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlayerLevel) {
                return this;
              }
              const copy = new PromotionBundleConfig_Filter_PlayerLevelFilter(this);
              copy._hasPlayerLevel = false;
              copy._playerLevel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPlayerLevel) {
            const copy = new PromotionBundleConfig_Filter_PlayerLevelFilter(this);
            copy._hasPlayerLevel = true;
            copy._playerLevel = dcei_wildsky_common_proto.IntRange.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._playerLevel.apply(type, path.slice(1), value);
          if (newValue === this._playerLevel) {
            return this;
          }
          const copy = new PromotionBundleConfig_Filter_PlayerLevelFilter(this);
          copy._playerLevel = copy._playerLevel.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PromotionBundleConfig_Filter_PlayerLevelFilter} other
   * @returns {PromotionBundleConfig_Filter_PlayerLevelFilter}
   */
  merge(other) {
    const copy = new PromotionBundleConfig_Filter_PlayerLevelFilter(this);
    if (other._hasPlayerLevel) {
      if (copy._hasPlayerLevel) {
        copy._playerLevel = copy.playerLevel.merge(other.playerLevel);
      } else {
        copy._playerLevel = other._playerLevel;
      }
      copy._hasPlayerLevel = true;
    }
    return copy;
  }
}
PromotionBundleConfig_Filter_PlayerLevelFilter.default = new PromotionBundleConfig_Filter_PlayerLevelFilter();
class PromotionBundleConfig_Filter_PlayerLevelFilter_Builder {
  constructor(value) {
    this._value = new PromotionBundleConfig_Filter_PlayerLevelFilter(value);
  }
  build() {
    return new PromotionBundleConfig_Filter_PlayerLevelFilter(this._value);
  }
  setPlayerLevel(value) {
    this._value._hasPlayerLevel = true;
    this._value._playerLevel = value;
    return this;
  }
  deletePlayerLevel() {
    this._value._hasPlayerLevel = false;
    this._value._playerLevel = null;
    return this;
  }
}
PromotionBundleConfig_Filter_PlayerLevelFilter.Builder = PromotionBundleConfig_Filter_PlayerLevelFilter_Builder;
class PromotionBundleConfig_Filter_PlayerLevelFilter_WithParent {
  /**
   * @param {PromotionBundleConfig_Filter_PlayerLevelFilter} value
   * @param {PromotionBundleConfig_Filter_PlayerLevelFilter_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PromotionBundleConfig_Filter_PlayerLevelFilter.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPlayerLevel() {
    if (this._cachedHasPlayerLevel === undefined) {
      if (this._value.hasPlayerLevel) {
        this._cachedHasPlayerLevel = true;
      } else {
        this._cachedHasPlayerLevel = this._parent ? this._parent.hasPlayerLevel : false;
      }
    }
    return this._cachedHasPlayerLevel;
  }
  get playerLevel() {
    if (!this._cachedPlayerLevel) {
      if (this._value.hasPlayerLevel) {
        this._cachedPlayerLevel = new dcei_wildsky_common_proto.IntRange.WithParent(this._value.playerLevel, this._parent && this._parent.hasPlayerLevel ? this._parent.playerLevel : null);
      } else {
        this._cachedPlayerLevel = this._parent ? new dcei_wildsky_common_proto.IntRange.WithParent(dcei_wildsky_common_proto.IntRange.default, this._parent.playerLevel) : dcei_wildsky_common_proto.IntRange.WithParent.default;
      }
    }
    return this._cachedPlayerLevel;
  }
  update(current, parent) {
    const result = new PromotionBundleConfig_Filter_PlayerLevelFilter_WithParent(current, parent);
    if (this._cachedPlayerLevel && this._value.hasPlayerLevel && current.hasPlayerLevel) {
      if (this._value.playerLevel === current.playerLevel && this._parent === parent) {
        result._cachedPlayerLevel = this._cachedPlayerLevel;
      } else {
        result._cachedPlayerLevel = this._cachedPlayerLevel.update(current.playerLevel, parent && parent.hasPlayerLevel ? parent.playerLevel : null);
      }
    }
    return result;
  }
}
PromotionBundleConfig_Filter_PlayerLevelFilter_WithParent.default = new PromotionBundleConfig_Filter_PlayerLevelFilter_WithParent(PromotionBundleConfig_Filter_PlayerLevelFilter.default, null);
PromotionBundleConfig_Filter_PlayerLevelFilter.WithParent = PromotionBundleConfig_Filter_PlayerLevelFilter_WithParent;
class PromotionBundleConfig_Filter_PlayerLevelFilter_Descriptor {
  get playerLevel() {
    if (!this._playerLevel) {
      this._playerLevel = {
        name: "playerLevel",
        Name: "PlayerLevel",
        number: 1,
        protoType: 11,
        protoName: "player_level",
        type: dcei_wildsky_common_proto.IntRange,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerLevel;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.playerLevel,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPlayerLevel",
        Name: "DummyOneofForPlayerLevel",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
PromotionBundleConfig_Filter_PlayerLevelFilter.descriptor = new PromotionBundleConfig_Filter_PlayerLevelFilter_Descriptor();
class PromotionBundleConfig_Filter_PlayerUuidFilter {
  get descriptor() {
    return PromotionBundleConfig_Filter_PlayerUuidFilter.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._uuids = [];
  }
  isEmpty() {
    if (this._uuids.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PromotionBundleConfig_Filter_PlayerUuidFilter) {
      return value;
    }
    return PromotionBundleConfig_Filter_PlayerUuidFilter.fromJson(value);
  }
  static fromJson(json) {
    const result = new PromotionBundleConfig_Filter_PlayerUuidFilter();
    result._uuids = JsonToList(json.uuids, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._uuids.length > 0) {
      result.uuids = ArrayToJson(this._uuids, JsonToString);
    }
    return result;
  }
  /**
   * @returns {string[]}
   */
  get uuids() {
    return this._uuids;
  }
  addUuids(path, value) {
    return {type: 'ADD', path: path.concat(['uuids']), value};
  }
  setUuids(path, value) {
    return {type: 'SET', path: path.concat(['uuids']), value: ArrayToJson(value, JsonToString)};
  }
  setUuidsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['uuids', key]), value};
  }
  deleteUuids(path) {
    return {type: 'DELETE', path: path.concat(['uuids'])};
  }
  deleteUuidsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['uuids', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "uuids": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfig_Filter_PlayerUuidFilter(this);
              copy._uuids = [];        for (let i of value) {
                copy._uuids.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new PromotionBundleConfig_Filter_PlayerUuidFilter(this);
              copy._uuids = copy._uuids.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._uuids.length === 0) {
                return this;
              }
              const copy = new PromotionBundleConfig_Filter_PlayerUuidFilter(this);
              copy._uuids = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._uuids.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfig_Filter_PlayerUuidFilter(this);
              copy._uuids = copy._uuids.slice();
              copy._uuids[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new PromotionBundleConfig_Filter_PlayerUuidFilter(this);
              copy._uuids = copy._uuids.slice(0, path[1]).concat(copy._uuids.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._uuids.length) {
            return this;
          }
          const oldValue = this._uuids[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new PromotionBundleConfig_Filter_PlayerUuidFilter(this);
          copy._uuids = copy._uuids.slice();
          copy._uuids[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PromotionBundleConfig_Filter_PlayerUuidFilter} other
   * @returns {PromotionBundleConfig_Filter_PlayerUuidFilter}
   */
  merge(other) {
    const copy = new PromotionBundleConfig_Filter_PlayerUuidFilter(this);
    copy._uuids = this._uuids.concat(other._uuids);
    return copy;
  }
}
PromotionBundleConfig_Filter_PlayerUuidFilter.default = new PromotionBundleConfig_Filter_PlayerUuidFilter();
class PromotionBundleConfig_Filter_PlayerUuidFilter_Builder {
  constructor(value) {
    this._value = new PromotionBundleConfig_Filter_PlayerUuidFilter(value);
  }
  build() {
    return new PromotionBundleConfig_Filter_PlayerUuidFilter(this._value);
  }
  addAllUuids(values) {
    this._value._uuids = this._value._uuids.concat(values);
    return this;
  }
  addUuids(value) {
    this._value._uuids = this._value._uuids.concat([value]);
    return this;
  }
  setUuids(index, value) {
    this._value._uuids = this._value._uuids.concat();
    this._value._uuids[index] = value;
    return this;
  }
  clearUuids() {
    this._value._uuids = [];
    return this;
  }
}
PromotionBundleConfig_Filter_PlayerUuidFilter.Builder = PromotionBundleConfig_Filter_PlayerUuidFilter_Builder;
class PromotionBundleConfig_Filter_PlayerUuidFilter_WithParent {
  /**
   * @param {PromotionBundleConfig_Filter_PlayerUuidFilter} value
   * @param {PromotionBundleConfig_Filter_PlayerUuidFilter_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PromotionBundleConfig_Filter_PlayerUuidFilter.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfUuids() {
    return this._value.uuids;
  }
  get inherentUuids() {
    if (!this._inherentUuids) {
      this._inherentUuids = this._parent ? this._parent.uuids : [];
    }
    return this._inherentUuids;
  }
  get uuids() {
    if (!this._allUuids) {
      this._allUuids = this._parent ? this._parent.uuids.concat(this.selfUuids) : this.selfUuids;
    }
    return this._allUuids;
  }
  update(current, parent) {
    const result = new PromotionBundleConfig_Filter_PlayerUuidFilter_WithParent(current, parent);
    return result;
  }
}
PromotionBundleConfig_Filter_PlayerUuidFilter_WithParent.default = new PromotionBundleConfig_Filter_PlayerUuidFilter_WithParent(PromotionBundleConfig_Filter_PlayerUuidFilter.default, null);
PromotionBundleConfig_Filter_PlayerUuidFilter.WithParent = PromotionBundleConfig_Filter_PlayerUuidFilter_WithParent;
class PromotionBundleConfig_Filter_PlayerUuidFilter_Descriptor {
  get uuids() {
    if (!this._uuids) {
      this._uuids = {
        name: "uuids",
        Name: "Uuids",
        number: 1,
        protoType: 9,
        protoName: "uuids",
        type: JsonToString,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._uuids;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.uuids,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
PromotionBundleConfig_Filter_PlayerUuidFilter.descriptor = new PromotionBundleConfig_Filter_PlayerUuidFilter_Descriptor();
class PromotionBundleConfig_Filter_CampaignProgressFilter {
  get descriptor() {
    return PromotionBundleConfig_Filter_CampaignProgressFilter.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCampaignProgress = false;
    this._campaignProgress = null;
  }
  isEmpty() {
    if (this._hasCampaignProgress && !this._campaignProgress.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PromotionBundleConfig_Filter_CampaignProgressFilter) {
      return value;
    }
    return PromotionBundleConfig_Filter_CampaignProgressFilter.fromJson(value);
  }
  static fromJson(json) {
    const result = new PromotionBundleConfig_Filter_CampaignProgressFilter();
    if (json.campaignProgress != null) {
      result._hasCampaignProgress = true;
      result._campaignProgress = dcei_wildsky_common_proto.IntRange.fromJson(json.campaignProgress);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCampaignProgress && !this._campaignProgress.isEmpty()) {
      result.campaignProgress = dcei_wildsky_common_proto.IntRange.toJson(this._campaignProgress);
    }
    return result;
  }
  /**
   * @returns {dcei_wildsky_common_proto.IntRange}
   */
  get campaignProgress() {
    return this._hasCampaignProgress ? this._campaignProgress : dcei_wildsky_common_proto.IntRange.default;
  }
  get hasCampaignProgress() {
    return this._hasCampaignProgress;
  }
  setCampaignProgress(path, value) {
    return {type: 'SET', path: path.concat(['campaignProgress']), value: value.toJson()};
  }
  deleteCampaignProgress(path) {
    return {type: 'DELETE', path: path.concat(['campaignProgress'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "campaignProgress": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfig_Filter_CampaignProgressFilter(this);
              copy._hasCampaignProgress = true;
              copy._campaignProgress = dcei_wildsky_common_proto.IntRange.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCampaignProgress) {
                return this;
              }
              const copy = new PromotionBundleConfig_Filter_CampaignProgressFilter(this);
              copy._hasCampaignProgress = false;
              copy._campaignProgress = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCampaignProgress) {
            const copy = new PromotionBundleConfig_Filter_CampaignProgressFilter(this);
            copy._hasCampaignProgress = true;
            copy._campaignProgress = dcei_wildsky_common_proto.IntRange.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._campaignProgress.apply(type, path.slice(1), value);
          if (newValue === this._campaignProgress) {
            return this;
          }
          const copy = new PromotionBundleConfig_Filter_CampaignProgressFilter(this);
          copy._campaignProgress = copy._campaignProgress.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PromotionBundleConfig_Filter_CampaignProgressFilter} other
   * @returns {PromotionBundleConfig_Filter_CampaignProgressFilter}
   */
  merge(other) {
    const copy = new PromotionBundleConfig_Filter_CampaignProgressFilter(this);
    if (other._hasCampaignProgress) {
      if (copy._hasCampaignProgress) {
        copy._campaignProgress = copy.campaignProgress.merge(other.campaignProgress);
      } else {
        copy._campaignProgress = other._campaignProgress;
      }
      copy._hasCampaignProgress = true;
    }
    return copy;
  }
}
PromotionBundleConfig_Filter_CampaignProgressFilter.default = new PromotionBundleConfig_Filter_CampaignProgressFilter();
class PromotionBundleConfig_Filter_CampaignProgressFilter_Builder {
  constructor(value) {
    this._value = new PromotionBundleConfig_Filter_CampaignProgressFilter(value);
  }
  build() {
    return new PromotionBundleConfig_Filter_CampaignProgressFilter(this._value);
  }
  setCampaignProgress(value) {
    this._value._hasCampaignProgress = true;
    this._value._campaignProgress = value;
    return this;
  }
  deleteCampaignProgress() {
    this._value._hasCampaignProgress = false;
    this._value._campaignProgress = null;
    return this;
  }
}
PromotionBundleConfig_Filter_CampaignProgressFilter.Builder = PromotionBundleConfig_Filter_CampaignProgressFilter_Builder;
class PromotionBundleConfig_Filter_CampaignProgressFilter_WithParent {
  /**
   * @param {PromotionBundleConfig_Filter_CampaignProgressFilter} value
   * @param {PromotionBundleConfig_Filter_CampaignProgressFilter_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PromotionBundleConfig_Filter_CampaignProgressFilter.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCampaignProgress() {
    if (this._cachedHasCampaignProgress === undefined) {
      if (this._value.hasCampaignProgress) {
        this._cachedHasCampaignProgress = true;
      } else {
        this._cachedHasCampaignProgress = this._parent ? this._parent.hasCampaignProgress : false;
      }
    }
    return this._cachedHasCampaignProgress;
  }
  get campaignProgress() {
    if (!this._cachedCampaignProgress) {
      if (this._value.hasCampaignProgress) {
        this._cachedCampaignProgress = new dcei_wildsky_common_proto.IntRange.WithParent(this._value.campaignProgress, this._parent && this._parent.hasCampaignProgress ? this._parent.campaignProgress : null);
      } else {
        this._cachedCampaignProgress = this._parent ? new dcei_wildsky_common_proto.IntRange.WithParent(dcei_wildsky_common_proto.IntRange.default, this._parent.campaignProgress) : dcei_wildsky_common_proto.IntRange.WithParent.default;
      }
    }
    return this._cachedCampaignProgress;
  }
  update(current, parent) {
    const result = new PromotionBundleConfig_Filter_CampaignProgressFilter_WithParent(current, parent);
    if (this._cachedCampaignProgress && this._value.hasCampaignProgress && current.hasCampaignProgress) {
      if (this._value.campaignProgress === current.campaignProgress && this._parent === parent) {
        result._cachedCampaignProgress = this._cachedCampaignProgress;
      } else {
        result._cachedCampaignProgress = this._cachedCampaignProgress.update(current.campaignProgress, parent && parent.hasCampaignProgress ? parent.campaignProgress : null);
      }
    }
    return result;
  }
}
PromotionBundleConfig_Filter_CampaignProgressFilter_WithParent.default = new PromotionBundleConfig_Filter_CampaignProgressFilter_WithParent(PromotionBundleConfig_Filter_CampaignProgressFilter.default, null);
PromotionBundleConfig_Filter_CampaignProgressFilter.WithParent = PromotionBundleConfig_Filter_CampaignProgressFilter_WithParent;
class PromotionBundleConfig_Filter_CampaignProgressFilter_Descriptor {
  get campaignProgress() {
    if (!this._campaignProgress) {
      this._campaignProgress = {
        name: "campaignProgress",
        Name: "CampaignProgress",
        number: 1,
        protoType: 11,
        protoName: "campaign_progress",
        type: dcei_wildsky_common_proto.IntRange,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._campaignProgress;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.campaignProgress,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCampaignProgress",
        Name: "DummyOneofForCampaignProgress",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
PromotionBundleConfig_Filter_CampaignProgressFilter.descriptor = new PromotionBundleConfig_Filter_CampaignProgressFilter_Descriptor();
class PromotionBundleConfig_Filter_CardSubscriptionFilter_CardType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "Privilege": return 0;
        case "Ultra": return 1;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return PromotionBundleConfig_Filter_CardSubscriptionFilter_CardType.fromJson(value);
  }
  static fromReact(e) {
    return PromotionBundleConfig_Filter_CardSubscriptionFilter_CardType.fromJson(e);
  }
}
PromotionBundleConfig_Filter_CardSubscriptionFilter_CardType.Privilege = 0;
PromotionBundleConfig_Filter_CardSubscriptionFilter_CardType.Ultra = 1;
PromotionBundleConfig_Filter_CardSubscriptionFilter_CardType.default = 0;
PromotionBundleConfig_Filter_CardSubscriptionFilter_CardType.values = {
  Privilege: 0,
  Ultra: 1,
};
PromotionBundleConfig_Filter_CardSubscriptionFilter_CardType.names = {
  0: "Privilege",
  1: "Ultra",
};
class PromotionBundleConfig_Filter_CardSubscriptionFilter_CardStatus {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "NEVER_BOUGHT": return 0;
        case "ACTIVE": return 1;
        case "EXPIRED": return 2;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return PromotionBundleConfig_Filter_CardSubscriptionFilter_CardStatus.fromJson(value);
  }
  static fromReact(e) {
    return PromotionBundleConfig_Filter_CardSubscriptionFilter_CardStatus.fromJson(e);
  }
}
PromotionBundleConfig_Filter_CardSubscriptionFilter_CardStatus.NEVER_BOUGHT = 0;
PromotionBundleConfig_Filter_CardSubscriptionFilter_CardStatus.ACTIVE = 1;
PromotionBundleConfig_Filter_CardSubscriptionFilter_CardStatus.EXPIRED = 2;
PromotionBundleConfig_Filter_CardSubscriptionFilter_CardStatus.default = 0;
PromotionBundleConfig_Filter_CardSubscriptionFilter_CardStatus.values = {
  NEVER_BOUGHT: 0,
  ACTIVE: 1,
  EXPIRED: 2,
};
PromotionBundleConfig_Filter_CardSubscriptionFilter_CardStatus.names = {
  0: "NEVER_BOUGHT",
  1: "ACTIVE",
  2: "EXPIRED",
};
class PromotionBundleConfig_Filter_CardSubscriptionFilter {
  get descriptor() {
    return PromotionBundleConfig_Filter_CardSubscriptionFilter.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCardType = false;
    this._cardType = null;
    this._hasCardStatus = false;
    this._cardStatus = null;
    this._hasExpriedDays = false;
    this._expriedDays = null;
  }
  isEmpty() {
    if (this._hasCardType) return false;
    if (this._hasCardStatus) return false;
    if (this._hasExpriedDays) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PromotionBundleConfig_Filter_CardSubscriptionFilter) {
      return value;
    }
    return PromotionBundleConfig_Filter_CardSubscriptionFilter.fromJson(value);
  }
  static fromJson(json) {
    const result = new PromotionBundleConfig_Filter_CardSubscriptionFilter();
    if (json.cardType != null) {
      result._hasCardType = true;
      result._cardType = PromotionBundleConfig_Filter_CardSubscriptionFilter_CardType.fromJson(json.cardType);
    }
    if (json.cardStatus != null) {
      result._hasCardStatus = true;
      result._cardStatus = PromotionBundleConfig_Filter_CardSubscriptionFilter_CardStatus.fromJson(json.cardStatus);
    }
    if (json.expriedDays != null) {
      result._hasExpriedDays = true;
      result._expriedDays = JsonToInt32.fromJson(json.expriedDays);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCardType) {
      result.cardType = PromotionBundleConfig_Filter_CardSubscriptionFilter_CardType.toJson(this._cardType);
    }
    if (this._hasCardStatus) {
      result.cardStatus = PromotionBundleConfig_Filter_CardSubscriptionFilter_CardStatus.toJson(this._cardStatus);
    }
    if (this._hasExpriedDays) {
      result.expriedDays = JsonToInt32.toJson(this._expriedDays);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get cardType() {
    return this._hasCardType ? this._cardType : PromotionBundleConfig_Filter_CardSubscriptionFilter_CardType.default;
  }
  get hasCardType() {
    return this._hasCardType;
  }
  setCardType(path, value) {
    return {type: 'SET', path: path.concat(['cardType']), value};
  }
  deleteCardType(path) {
    return {type: 'DELETE', path: path.concat(['cardType'])};
  }
  /**
   * @returns {number}
   */
  get cardStatus() {
    return this._hasCardStatus ? this._cardStatus : PromotionBundleConfig_Filter_CardSubscriptionFilter_CardStatus.default;
  }
  get hasCardStatus() {
    return this._hasCardStatus;
  }
  setCardStatus(path, value) {
    return {type: 'SET', path: path.concat(['cardStatus']), value};
  }
  deleteCardStatus(path) {
    return {type: 'DELETE', path: path.concat(['cardStatus'])};
  }
  /**
   * @returns {number}
   */
  get expriedDays() {
    return this._hasExpriedDays ? this._expriedDays : JsonToInt32.default;
  }
  get hasExpriedDays() {
    return this._hasExpriedDays;
  }
  setExpriedDays(path, value) {
    return {type: 'SET', path: path.concat(['expriedDays']), value};
  }
  deleteExpriedDays(path) {
    return {type: 'DELETE', path: path.concat(['expriedDays'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "cardType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfig_Filter_CardSubscriptionFilter(this);
              copy._hasCardType = true;
              copy._cardType = PromotionBundleConfig_Filter_CardSubscriptionFilter_CardType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardType) {
                return this;
              }
              const copy = new PromotionBundleConfig_Filter_CardSubscriptionFilter(this);
              copy._hasCardType = false;
              copy._cardType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cardStatus": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfig_Filter_CardSubscriptionFilter(this);
              copy._hasCardStatus = true;
              copy._cardStatus = PromotionBundleConfig_Filter_CardSubscriptionFilter_CardStatus.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardStatus) {
                return this;
              }
              const copy = new PromotionBundleConfig_Filter_CardSubscriptionFilter(this);
              copy._hasCardStatus = false;
              copy._cardStatus = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "expriedDays": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfig_Filter_CardSubscriptionFilter(this);
              copy._hasExpriedDays = true;
              copy._expriedDays = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasExpriedDays) {
                return this;
              }
              const copy = new PromotionBundleConfig_Filter_CardSubscriptionFilter(this);
              copy._hasExpriedDays = false;
              copy._expriedDays = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PromotionBundleConfig_Filter_CardSubscriptionFilter} other
   * @returns {PromotionBundleConfig_Filter_CardSubscriptionFilter}
   */
  merge(other) {
    const copy = new PromotionBundleConfig_Filter_CardSubscriptionFilter(this);
    if (other._hasCardType) {
      copy._hasCardType = true;
      copy._cardType = other._cardType;
    }
    if (other._hasCardStatus) {
      copy._hasCardStatus = true;
      copy._cardStatus = other._cardStatus;
    }
    if (other._hasExpriedDays) {
      copy._hasExpriedDays = true;
      copy._expriedDays = other._expriedDays;
    }
    return copy;
  }
}
PromotionBundleConfig_Filter_CardSubscriptionFilter.default = new PromotionBundleConfig_Filter_CardSubscriptionFilter();
PromotionBundleConfig_Filter_CardSubscriptionFilter.CardType = PromotionBundleConfig_Filter_CardSubscriptionFilter_CardType;
PromotionBundleConfig_Filter_CardSubscriptionFilter.CardStatus = PromotionBundleConfig_Filter_CardSubscriptionFilter_CardStatus;
class PromotionBundleConfig_Filter_CardSubscriptionFilter_Builder {
  constructor(value) {
    this._value = new PromotionBundleConfig_Filter_CardSubscriptionFilter(value);
  }
  build() {
    return new PromotionBundleConfig_Filter_CardSubscriptionFilter(this._value);
  }
  setCardType(value) {
    this._value._hasCardType = true;
    this._value._cardType = value;
    return this;
  }
  deleteCardType() {
    this._value._hasCardType = false;
    this._value._cardType = null;
    return this;
  }
  setCardStatus(value) {
    this._value._hasCardStatus = true;
    this._value._cardStatus = value;
    return this;
  }
  deleteCardStatus() {
    this._value._hasCardStatus = false;
    this._value._cardStatus = null;
    return this;
  }
  setExpriedDays(value) {
    this._value._hasExpriedDays = true;
    this._value._expriedDays = value;
    return this;
  }
  deleteExpriedDays() {
    this._value._hasExpriedDays = false;
    this._value._expriedDays = null;
    return this;
  }
}
PromotionBundleConfig_Filter_CardSubscriptionFilter.Builder = PromotionBundleConfig_Filter_CardSubscriptionFilter_Builder;
class PromotionBundleConfig_Filter_CardSubscriptionFilter_WithParent {
  /**
   * @param {PromotionBundleConfig_Filter_CardSubscriptionFilter} value
   * @param {PromotionBundleConfig_Filter_CardSubscriptionFilter_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PromotionBundleConfig_Filter_CardSubscriptionFilter.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCardType() {
    if (this._cachedHasCardType === undefined) {
      if (this._value.hasCardType) {
        this._cachedHasCardType = true;
      } else {
        this._cachedHasCardType = this._parent ? this._parent.hasCardType : false;
      }
    }
    return this._cachedHasCardType;
  }
  get cardType() {
    if (this._cachedCardType === undefined) {
      if (this._value.hasCardType) {
        this._cachedCardType = this._value.cardType;
      } else {
        this._cachedCardType = this._parent ? this._parent.cardType : this._value.cardType;
      }
    }
    return this._cachedCardType;
  }
  get hasCardStatus() {
    if (this._cachedHasCardStatus === undefined) {
      if (this._value.hasCardStatus) {
        this._cachedHasCardStatus = true;
      } else {
        this._cachedHasCardStatus = this._parent ? this._parent.hasCardStatus : false;
      }
    }
    return this._cachedHasCardStatus;
  }
  get cardStatus() {
    if (this._cachedCardStatus === undefined) {
      if (this._value.hasCardStatus) {
        this._cachedCardStatus = this._value.cardStatus;
      } else {
        this._cachedCardStatus = this._parent ? this._parent.cardStatus : this._value.cardStatus;
      }
    }
    return this._cachedCardStatus;
  }
  get hasExpriedDays() {
    if (this._cachedHasExpriedDays === undefined) {
      if (this._value.hasExpriedDays) {
        this._cachedHasExpriedDays = true;
      } else {
        this._cachedHasExpriedDays = this._parent ? this._parent.hasExpriedDays : false;
      }
    }
    return this._cachedHasExpriedDays;
  }
  get expriedDays() {
    if (this._cachedExpriedDays === undefined) {
      if (this._value.hasExpriedDays) {
        this._cachedExpriedDays = this._value.expriedDays;
      } else {
        this._cachedExpriedDays = this._parent ? this._parent.expriedDays : this._value.expriedDays;
      }
    }
    return this._cachedExpriedDays;
  }
  update(current, parent) {
    const result = new PromotionBundleConfig_Filter_CardSubscriptionFilter_WithParent(current, parent);
    return result;
  }
}
PromotionBundleConfig_Filter_CardSubscriptionFilter_WithParent.default = new PromotionBundleConfig_Filter_CardSubscriptionFilter_WithParent(PromotionBundleConfig_Filter_CardSubscriptionFilter.default, null);
PromotionBundleConfig_Filter_CardSubscriptionFilter.WithParent = PromotionBundleConfig_Filter_CardSubscriptionFilter_WithParent;
class PromotionBundleConfig_Filter_CardSubscriptionFilter_Descriptor {
  get cardType() {
    if (!this._cardType) {
      this._cardType = {
        name: "cardType",
        Name: "CardType",
        number: 1,
        protoType: 14,
        protoName: "card_type",
        type: PromotionBundleConfig_Filter_CardSubscriptionFilter_CardType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardType;
  }
  get cardStatus() {
    if (!this._cardStatus) {
      this._cardStatus = {
        name: "cardStatus",
        Name: "CardStatus",
        number: 2,
        protoType: 14,
        protoName: "card_status",
        type: PromotionBundleConfig_Filter_CardSubscriptionFilter_CardStatus,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardStatus;
  }
  get expriedDays() {
    if (!this._expriedDays) {
      this._expriedDays = {
        name: "expriedDays",
        Name: "ExpriedDays",
        number: 3,
        protoType: 5,
        protoName: "expried_days",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._expriedDays;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.cardType,
        this.cardStatus,
        this.expriedDays,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCardType",
        Name: "DummyOneofForCardType",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCardStatus",
        Name: "DummyOneofForCardStatus",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForExpriedDays",
        Name: "DummyOneofForExpriedDays",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
PromotionBundleConfig_Filter_CardSubscriptionFilter.descriptor = new PromotionBundleConfig_Filter_CardSubscriptionFilter_Descriptor();
class PromotionBundleConfig_Filter_GoldPassFilter {
  get descriptor() {
    return PromotionBundleConfig_Filter_GoldPassFilter.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasActivated = false;
    this._activated = null;
  }
  isEmpty() {
    if (this._hasActivated) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PromotionBundleConfig_Filter_GoldPassFilter) {
      return value;
    }
    return PromotionBundleConfig_Filter_GoldPassFilter.fromJson(value);
  }
  static fromJson(json) {
    const result = new PromotionBundleConfig_Filter_GoldPassFilter();
    if (json.activated != null) {
      result._hasActivated = true;
      result._activated = JsonToBoolean.fromJson(json.activated);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasActivated) {
      result.activated = JsonToBoolean.toJson(this._activated);
    }
    return result;
  }
  /**
   * @returns {boolean}
   */
  get activated() {
    return this._hasActivated ? this._activated : JsonToBoolean.default;
  }
  get hasActivated() {
    return this._hasActivated;
  }
  setActivated(path, value) {
    return {type: 'SET', path: path.concat(['activated']), value};
  }
  deleteActivated(path) {
    return {type: 'DELETE', path: path.concat(['activated'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "activated": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfig_Filter_GoldPassFilter(this);
              copy._hasActivated = true;
              copy._activated = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasActivated) {
                return this;
              }
              const copy = new PromotionBundleConfig_Filter_GoldPassFilter(this);
              copy._hasActivated = false;
              copy._activated = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PromotionBundleConfig_Filter_GoldPassFilter} other
   * @returns {PromotionBundleConfig_Filter_GoldPassFilter}
   */
  merge(other) {
    const copy = new PromotionBundleConfig_Filter_GoldPassFilter(this);
    if (other._hasActivated) {
      copy._hasActivated = true;
      copy._activated = other._activated;
    }
    return copy;
  }
}
PromotionBundleConfig_Filter_GoldPassFilter.default = new PromotionBundleConfig_Filter_GoldPassFilter();
class PromotionBundleConfig_Filter_GoldPassFilter_Builder {
  constructor(value) {
    this._value = new PromotionBundleConfig_Filter_GoldPassFilter(value);
  }
  build() {
    return new PromotionBundleConfig_Filter_GoldPassFilter(this._value);
  }
  setActivated(value) {
    this._value._hasActivated = true;
    this._value._activated = value;
    return this;
  }
  deleteActivated() {
    this._value._hasActivated = false;
    this._value._activated = null;
    return this;
  }
}
PromotionBundleConfig_Filter_GoldPassFilter.Builder = PromotionBundleConfig_Filter_GoldPassFilter_Builder;
class PromotionBundleConfig_Filter_GoldPassFilter_WithParent {
  /**
   * @param {PromotionBundleConfig_Filter_GoldPassFilter} value
   * @param {PromotionBundleConfig_Filter_GoldPassFilter_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PromotionBundleConfig_Filter_GoldPassFilter.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasActivated() {
    if (this._cachedHasActivated === undefined) {
      if (this._value.hasActivated) {
        this._cachedHasActivated = true;
      } else {
        this._cachedHasActivated = this._parent ? this._parent.hasActivated : false;
      }
    }
    return this._cachedHasActivated;
  }
  get activated() {
    if (this._cachedActivated === undefined) {
      if (this._value.hasActivated) {
        this._cachedActivated = this._value.activated;
      } else {
        this._cachedActivated = this._parent ? this._parent.activated : this._value.activated;
      }
    }
    return this._cachedActivated;
  }
  update(current, parent) {
    const result = new PromotionBundleConfig_Filter_GoldPassFilter_WithParent(current, parent);
    return result;
  }
}
PromotionBundleConfig_Filter_GoldPassFilter_WithParent.default = new PromotionBundleConfig_Filter_GoldPassFilter_WithParent(PromotionBundleConfig_Filter_GoldPassFilter.default, null);
PromotionBundleConfig_Filter_GoldPassFilter.WithParent = PromotionBundleConfig_Filter_GoldPassFilter_WithParent;
class PromotionBundleConfig_Filter_GoldPassFilter_Descriptor {
  get activated() {
    if (!this._activated) {
      this._activated = {
        name: "activated",
        Name: "Activated",
        number: 1,
        protoType: 8,
        protoName: "activated",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._activated;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.activated,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForActivated",
        Name: "DummyOneofForActivated",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
PromotionBundleConfig_Filter_GoldPassFilter.descriptor = new PromotionBundleConfig_Filter_GoldPassFilter_Descriptor();
class PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter {
  get descriptor() {
    return PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasBundleId = false;
    this._bundleId = null;
    this._hasPurchasedBefore = false;
    this._purchasedBefore = null;
  }
  isEmpty() {
    if (this._hasBundleId) return false;
    if (this._hasPurchasedBefore) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter) {
      return value;
    }
    return PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter.fromJson(value);
  }
  static fromJson(json) {
    const result = new PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter();
    if (json.bundleId != null) {
      result._hasBundleId = true;
      result._bundleId = JsonToString.fromJson(json.bundleId);
    }
    if (json.purchasedBefore != null) {
      result._hasPurchasedBefore = true;
      result._purchasedBefore = JsonToBoolean.fromJson(json.purchasedBefore);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasBundleId) {
      result.bundleId = JsonToString.toJson(this._bundleId);
    }
    if (this._hasPurchasedBefore) {
      result.purchasedBefore = JsonToBoolean.toJson(this._purchasedBefore);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get bundleId() {
    return this._hasBundleId ? this._bundleId : JsonToString.default;
  }
  get hasBundleId() {
    return this._hasBundleId;
  }
  setBundleId(path, value) {
    return {type: 'SET', path: path.concat(['bundleId']), value};
  }
  deleteBundleId(path) {
    return {type: 'DELETE', path: path.concat(['bundleId'])};
  }
  /**
   * @returns {boolean}
   */
  get purchasedBefore() {
    return this._hasPurchasedBefore ? this._purchasedBefore : JsonToBoolean.default;
  }
  get hasPurchasedBefore() {
    return this._hasPurchasedBefore;
  }
  setPurchasedBefore(path, value) {
    return {type: 'SET', path: path.concat(['purchasedBefore']), value};
  }
  deletePurchasedBefore(path) {
    return {type: 'DELETE', path: path.concat(['purchasedBefore'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "bundleId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter(this);
              copy._hasBundleId = true;
              copy._bundleId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBundleId) {
                return this;
              }
              const copy = new PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter(this);
              copy._hasBundleId = false;
              copy._bundleId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "purchasedBefore": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter(this);
              copy._hasPurchasedBefore = true;
              copy._purchasedBefore = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPurchasedBefore) {
                return this;
              }
              const copy = new PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter(this);
              copy._hasPurchasedBefore = false;
              copy._purchasedBefore = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter} other
   * @returns {PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter}
   */
  merge(other) {
    const copy = new PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter(this);
    if (other._hasBundleId) {
      copy._hasBundleId = true;
      copy._bundleId = other._bundleId;
    }
    if (other._hasPurchasedBefore) {
      copy._hasPurchasedBefore = true;
      copy._purchasedBefore = other._purchasedBefore;
    }
    return copy;
  }
}
PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter.default = new PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter();
class PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter_Builder {
  constructor(value) {
    this._value = new PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter(value);
  }
  build() {
    return new PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter(this._value);
  }
  setBundleId(value) {
    this._value._hasBundleId = true;
    this._value._bundleId = value;
    return this;
  }
  deleteBundleId() {
    this._value._hasBundleId = false;
    this._value._bundleId = null;
    return this;
  }
  setPurchasedBefore(value) {
    this._value._hasPurchasedBefore = true;
    this._value._purchasedBefore = value;
    return this;
  }
  deletePurchasedBefore() {
    this._value._hasPurchasedBefore = false;
    this._value._purchasedBefore = null;
    return this;
  }
}
PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter.Builder = PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter_Builder;
class PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter_WithParent {
  /**
   * @param {PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter} value
   * @param {PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasBundleId() {
    if (this._cachedHasBundleId === undefined) {
      if (this._value.hasBundleId) {
        this._cachedHasBundleId = true;
      } else {
        this._cachedHasBundleId = this._parent ? this._parent.hasBundleId : false;
      }
    }
    return this._cachedHasBundleId;
  }
  get bundleId() {
    if (this._cachedBundleId === undefined) {
      if (this._value.hasBundleId) {
        this._cachedBundleId = this._value.bundleId;
      } else {
        this._cachedBundleId = this._parent ? this._parent.bundleId : this._value.bundleId;
      }
    }
    return this._cachedBundleId;
  }
  get hasPurchasedBefore() {
    if (this._cachedHasPurchasedBefore === undefined) {
      if (this._value.hasPurchasedBefore) {
        this._cachedHasPurchasedBefore = true;
      } else {
        this._cachedHasPurchasedBefore = this._parent ? this._parent.hasPurchasedBefore : false;
      }
    }
    return this._cachedHasPurchasedBefore;
  }
  get purchasedBefore() {
    if (this._cachedPurchasedBefore === undefined) {
      if (this._value.hasPurchasedBefore) {
        this._cachedPurchasedBefore = this._value.purchasedBefore;
      } else {
        this._cachedPurchasedBefore = this._parent ? this._parent.purchasedBefore : this._value.purchasedBefore;
      }
    }
    return this._cachedPurchasedBefore;
  }
  update(current, parent) {
    const result = new PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter_WithParent(current, parent);
    return result;
  }
}
PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter_WithParent.default = new PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter_WithParent(PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter.default, null);
PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter.WithParent = PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter_WithParent;
class PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter_Descriptor {
  get bundleId() {
    if (!this._bundleId) {
      this._bundleId = {
        name: "bundleId",
        Name: "BundleId",
        number: 1,
        protoType: 9,
        protoName: "bundle_id",
        type: JsonToString,
        options: {
          valueDropdown: "IapBundleList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._bundleId;
  }
  get purchasedBefore() {
    if (!this._purchasedBefore) {
      this._purchasedBefore = {
        name: "purchasedBefore",
        Name: "PurchasedBefore",
        number: 2,
        protoType: 8,
        protoName: "purchased_before",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._purchasedBefore;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.bundleId,
        this.purchasedBefore,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForBundleId",
        Name: "DummyOneofForBundleId",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPurchasedBefore",
        Name: "DummyOneofForPurchasedBefore",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter.descriptor = new PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter_Descriptor();
class PromotionBundleConfig_Filter_Operation {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "AND": return 0;
        case "OR": return 1;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return PromotionBundleConfig_Filter_Operation.fromJson(value);
  }
  static fromReact(e) {
    return PromotionBundleConfig_Filter_Operation.fromJson(e);
  }
}
PromotionBundleConfig_Filter_Operation.AND = 0;
PromotionBundleConfig_Filter_Operation.OR = 1;
PromotionBundleConfig_Filter_Operation.default = 0;
PromotionBundleConfig_Filter_Operation.values = {
  AND: 0,
  OR: 1,
};
PromotionBundleConfig_Filter_Operation.names = {
  0: "AND",
  1: "OR",
};
class PromotionBundleConfig_Filter {
  get descriptor() {
    return PromotionBundleConfig_Filter.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._filterTypeCase = 0;
    this._filterTypeValue = null;
    this._hasOperation = false;
    this._operation = null;
  }
  isEmpty() {
    if (this._filterTypeCase !== 0) return false;
    if (this._hasOperation) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PromotionBundleConfig_Filter) {
      return value;
    }
    return PromotionBundleConfig_Filter.fromJson(value);
  }
  static fromJson(json) {
    const result = new PromotionBundleConfig_Filter();
    if (json.dateFilter != null) {
      result._filterTypeCase = 1;
      result._filterTypeValue = PromotionBundleConfig_Filter_DateFilter.fromJson(json.dateFilter);
    }
    if (json.dailyProgressFilter != null) {
      result._filterTypeCase = 2;
      result._filterTypeValue = PromotionBundleConfig_Filter_DailyProgressFilter.fromJson(json.dailyProgressFilter);
    }
    if (json.playerLevelFilter != null) {
      result._filterTypeCase = 3;
      result._filterTypeValue = PromotionBundleConfig_Filter_PlayerLevelFilter.fromJson(json.playerLevelFilter);
    }
    if (json.playerUuidFilter != null) {
      result._filterTypeCase = 4;
      result._filterTypeValue = PromotionBundleConfig_Filter_PlayerUuidFilter.fromJson(json.playerUuidFilter);
    }
    if (json.campaignProgressFilter != null) {
      result._filterTypeCase = 5;
      result._filterTypeValue = PromotionBundleConfig_Filter_CampaignProgressFilter.fromJson(json.campaignProgressFilter);
    }
    if (json.cardSubscriptionFilter != null) {
      result._filterTypeCase = 6;
      result._filterTypeValue = PromotionBundleConfig_Filter_CardSubscriptionFilter.fromJson(json.cardSubscriptionFilter);
    }
    if (json.goldPassFilter != null) {
      result._filterTypeCase = 7;
      result._filterTypeValue = PromotionBundleConfig_Filter_GoldPassFilter.fromJson(json.goldPassFilter);
    }
    if (json.bundlePurchaseHistoryFilter != null) {
      result._filterTypeCase = 8;
      result._filterTypeValue = PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter.fromJson(json.bundlePurchaseHistoryFilter);
    }
    if (json.operation != null) {
      result._hasOperation = true;
      result._operation = PromotionBundleConfig_Filter_Operation.fromJson(json.operation);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._filterTypeCase) {
      case 1:
        result.dateFilter = PromotionBundleConfig_Filter_DateFilter.toJson(this._filterTypeValue);
        break;
      case 2:
        result.dailyProgressFilter = PromotionBundleConfig_Filter_DailyProgressFilter.toJson(this._filterTypeValue);
        break;
      case 3:
        result.playerLevelFilter = PromotionBundleConfig_Filter_PlayerLevelFilter.toJson(this._filterTypeValue);
        break;
      case 4:
        result.playerUuidFilter = PromotionBundleConfig_Filter_PlayerUuidFilter.toJson(this._filterTypeValue);
        break;
      case 5:
        result.campaignProgressFilter = PromotionBundleConfig_Filter_CampaignProgressFilter.toJson(this._filterTypeValue);
        break;
      case 6:
        result.cardSubscriptionFilter = PromotionBundleConfig_Filter_CardSubscriptionFilter.toJson(this._filterTypeValue);
        break;
      case 7:
        result.goldPassFilter = PromotionBundleConfig_Filter_GoldPassFilter.toJson(this._filterTypeValue);
        break;
      case 8:
        result.bundlePurchaseHistoryFilter = PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter.toJson(this._filterTypeValue);
        break;
      default:
        break;
    }
    if (this._hasOperation) {
      result.operation = PromotionBundleConfig_Filter_Operation.toJson(this._operation);
    }
    return result;
  }
  get filterTypeCase() {
    return this._filterTypeCase;
  }
  deleteFilterType(path) {
    switch (this._filterTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['dateFilter'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['dailyProgressFilter'])};
      }
      case 3: {
        return {type: 'DELETE', path: path.concat(['playerLevelFilter'])};
      }
      case 4: {
        return {type: 'DELETE', path: path.concat(['playerUuidFilter'])};
      }
      case 5: {
        return {type: 'DELETE', path: path.concat(['campaignProgressFilter'])};
      }
      case 6: {
        return {type: 'DELETE', path: path.concat(['cardSubscriptionFilter'])};
      }
      case 7: {
        return {type: 'DELETE', path: path.concat(['goldPassFilter'])};
      }
      case 8: {
        return {type: 'DELETE', path: path.concat(['bundlePurchaseHistoryFilter'])};
      }
    }
  }
  /**
   * @returns {PromotionBundleConfig_Filter_DateFilter}
   */
  get dateFilter() {
    return this._filterTypeCase === 1 ? this._filterTypeValue : PromotionBundleConfig_Filter_DateFilter.default;
  }
  setDateFilter(path, value) {
    return {type: 'SET', path: path.concat(['dateFilter']), value: value.toJson()};
  }
  deleteDateFilter(path) {
    return {type: 'DELETE', path: path.concat(['dateFilter'])};
  }
  /**
   * @returns {PromotionBundleConfig_Filter_DailyProgressFilter}
   */
  get dailyProgressFilter() {
    return this._filterTypeCase === 2 ? this._filterTypeValue : PromotionBundleConfig_Filter_DailyProgressFilter.default;
  }
  setDailyProgressFilter(path, value) {
    return {type: 'SET', path: path.concat(['dailyProgressFilter']), value: value.toJson()};
  }
  deleteDailyProgressFilter(path) {
    return {type: 'DELETE', path: path.concat(['dailyProgressFilter'])};
  }
  /**
   * @returns {PromotionBundleConfig_Filter_PlayerLevelFilter}
   */
  get playerLevelFilter() {
    return this._filterTypeCase === 3 ? this._filterTypeValue : PromotionBundleConfig_Filter_PlayerLevelFilter.default;
  }
  setPlayerLevelFilter(path, value) {
    return {type: 'SET', path: path.concat(['playerLevelFilter']), value: value.toJson()};
  }
  deletePlayerLevelFilter(path) {
    return {type: 'DELETE', path: path.concat(['playerLevelFilter'])};
  }
  /**
   * @returns {PromotionBundleConfig_Filter_PlayerUuidFilter}
   */
  get playerUuidFilter() {
    return this._filterTypeCase === 4 ? this._filterTypeValue : PromotionBundleConfig_Filter_PlayerUuidFilter.default;
  }
  setPlayerUuidFilter(path, value) {
    return {type: 'SET', path: path.concat(['playerUuidFilter']), value: value.toJson()};
  }
  deletePlayerUuidFilter(path) {
    return {type: 'DELETE', path: path.concat(['playerUuidFilter'])};
  }
  /**
   * @returns {PromotionBundleConfig_Filter_CampaignProgressFilter}
   */
  get campaignProgressFilter() {
    return this._filterTypeCase === 5 ? this._filterTypeValue : PromotionBundleConfig_Filter_CampaignProgressFilter.default;
  }
  setCampaignProgressFilter(path, value) {
    return {type: 'SET', path: path.concat(['campaignProgressFilter']), value: value.toJson()};
  }
  deleteCampaignProgressFilter(path) {
    return {type: 'DELETE', path: path.concat(['campaignProgressFilter'])};
  }
  /**
   * @returns {PromotionBundleConfig_Filter_CardSubscriptionFilter}
   */
  get cardSubscriptionFilter() {
    return this._filterTypeCase === 6 ? this._filterTypeValue : PromotionBundleConfig_Filter_CardSubscriptionFilter.default;
  }
  setCardSubscriptionFilter(path, value) {
    return {type: 'SET', path: path.concat(['cardSubscriptionFilter']), value: value.toJson()};
  }
  deleteCardSubscriptionFilter(path) {
    return {type: 'DELETE', path: path.concat(['cardSubscriptionFilter'])};
  }
  /**
   * @returns {PromotionBundleConfig_Filter_GoldPassFilter}
   */
  get goldPassFilter() {
    return this._filterTypeCase === 7 ? this._filterTypeValue : PromotionBundleConfig_Filter_GoldPassFilter.default;
  }
  setGoldPassFilter(path, value) {
    return {type: 'SET', path: path.concat(['goldPassFilter']), value: value.toJson()};
  }
  deleteGoldPassFilter(path) {
    return {type: 'DELETE', path: path.concat(['goldPassFilter'])};
  }
  /**
   * @returns {PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter}
   */
  get bundlePurchaseHistoryFilter() {
    return this._filterTypeCase === 8 ? this._filterTypeValue : PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter.default;
  }
  setBundlePurchaseHistoryFilter(path, value) {
    return {type: 'SET', path: path.concat(['bundlePurchaseHistoryFilter']), value: value.toJson()};
  }
  deleteBundlePurchaseHistoryFilter(path) {
    return {type: 'DELETE', path: path.concat(['bundlePurchaseHistoryFilter'])};
  }
  /**
   * @returns {number}
   */
  get operation() {
    return this._hasOperation ? this._operation : PromotionBundleConfig_Filter_Operation.default;
  }
  get hasOperation() {
    return this._hasOperation;
  }
  setOperation(path, value) {
    return {type: 'SET', path: path.concat(['operation']), value};
  }
  deleteOperation(path) {
    return {type: 'DELETE', path: path.concat(['operation'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "dateFilter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfig_Filter(this);
              copy._filterTypeCase = 1;
              copy._filterTypeValue = PromotionBundleConfig_Filter_DateFilter.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._filterTypeCase !== 1) {
                return this;
              }
              const copy = new PromotionBundleConfig_Filter(this);
              copy._filterTypeCase = 0;
              copy._filterTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._filterTypeCase !== 1) {
            const copy = new PromotionBundleConfig_Filter(this);
            copy._filterTypeCase = 1;
            copy._filterTypeValue = PromotionBundleConfig_Filter_DateFilter.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.dateFilter.apply(type, path.slice(1), value);
          if (newValue === this.dateFilter) {
            return this;
          }
          const copy = new PromotionBundleConfig_Filter(this);
          copy._filterTypeCase = 1;
          copy._filterTypeValue = newValue;
          return copy;
        }
      }
      case "dailyProgressFilter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfig_Filter(this);
              copy._filterTypeCase = 2;
              copy._filterTypeValue = PromotionBundleConfig_Filter_DailyProgressFilter.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._filterTypeCase !== 2) {
                return this;
              }
              const copy = new PromotionBundleConfig_Filter(this);
              copy._filterTypeCase = 0;
              copy._filterTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._filterTypeCase !== 2) {
            const copy = new PromotionBundleConfig_Filter(this);
            copy._filterTypeCase = 2;
            copy._filterTypeValue = PromotionBundleConfig_Filter_DailyProgressFilter.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.dailyProgressFilter.apply(type, path.slice(1), value);
          if (newValue === this.dailyProgressFilter) {
            return this;
          }
          const copy = new PromotionBundleConfig_Filter(this);
          copy._filterTypeCase = 2;
          copy._filterTypeValue = newValue;
          return copy;
        }
      }
      case "playerLevelFilter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfig_Filter(this);
              copy._filterTypeCase = 3;
              copy._filterTypeValue = PromotionBundleConfig_Filter_PlayerLevelFilter.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._filterTypeCase !== 3) {
                return this;
              }
              const copy = new PromotionBundleConfig_Filter(this);
              copy._filterTypeCase = 0;
              copy._filterTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._filterTypeCase !== 3) {
            const copy = new PromotionBundleConfig_Filter(this);
            copy._filterTypeCase = 3;
            copy._filterTypeValue = PromotionBundleConfig_Filter_PlayerLevelFilter.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.playerLevelFilter.apply(type, path.slice(1), value);
          if (newValue === this.playerLevelFilter) {
            return this;
          }
          const copy = new PromotionBundleConfig_Filter(this);
          copy._filterTypeCase = 3;
          copy._filterTypeValue = newValue;
          return copy;
        }
      }
      case "playerUuidFilter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfig_Filter(this);
              copy._filterTypeCase = 4;
              copy._filterTypeValue = PromotionBundleConfig_Filter_PlayerUuidFilter.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._filterTypeCase !== 4) {
                return this;
              }
              const copy = new PromotionBundleConfig_Filter(this);
              copy._filterTypeCase = 0;
              copy._filterTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._filterTypeCase !== 4) {
            const copy = new PromotionBundleConfig_Filter(this);
            copy._filterTypeCase = 4;
            copy._filterTypeValue = PromotionBundleConfig_Filter_PlayerUuidFilter.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.playerUuidFilter.apply(type, path.slice(1), value);
          if (newValue === this.playerUuidFilter) {
            return this;
          }
          const copy = new PromotionBundleConfig_Filter(this);
          copy._filterTypeCase = 4;
          copy._filterTypeValue = newValue;
          return copy;
        }
      }
      case "campaignProgressFilter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfig_Filter(this);
              copy._filterTypeCase = 5;
              copy._filterTypeValue = PromotionBundleConfig_Filter_CampaignProgressFilter.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._filterTypeCase !== 5) {
                return this;
              }
              const copy = new PromotionBundleConfig_Filter(this);
              copy._filterTypeCase = 0;
              copy._filterTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._filterTypeCase !== 5) {
            const copy = new PromotionBundleConfig_Filter(this);
            copy._filterTypeCase = 5;
            copy._filterTypeValue = PromotionBundleConfig_Filter_CampaignProgressFilter.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.campaignProgressFilter.apply(type, path.slice(1), value);
          if (newValue === this.campaignProgressFilter) {
            return this;
          }
          const copy = new PromotionBundleConfig_Filter(this);
          copy._filterTypeCase = 5;
          copy._filterTypeValue = newValue;
          return copy;
        }
      }
      case "cardSubscriptionFilter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfig_Filter(this);
              copy._filterTypeCase = 6;
              copy._filterTypeValue = PromotionBundleConfig_Filter_CardSubscriptionFilter.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._filterTypeCase !== 6) {
                return this;
              }
              const copy = new PromotionBundleConfig_Filter(this);
              copy._filterTypeCase = 0;
              copy._filterTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._filterTypeCase !== 6) {
            const copy = new PromotionBundleConfig_Filter(this);
            copy._filterTypeCase = 6;
            copy._filterTypeValue = PromotionBundleConfig_Filter_CardSubscriptionFilter.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.cardSubscriptionFilter.apply(type, path.slice(1), value);
          if (newValue === this.cardSubscriptionFilter) {
            return this;
          }
          const copy = new PromotionBundleConfig_Filter(this);
          copy._filterTypeCase = 6;
          copy._filterTypeValue = newValue;
          return copy;
        }
      }
      case "goldPassFilter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfig_Filter(this);
              copy._filterTypeCase = 7;
              copy._filterTypeValue = PromotionBundleConfig_Filter_GoldPassFilter.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._filterTypeCase !== 7) {
                return this;
              }
              const copy = new PromotionBundleConfig_Filter(this);
              copy._filterTypeCase = 0;
              copy._filterTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._filterTypeCase !== 7) {
            const copy = new PromotionBundleConfig_Filter(this);
            copy._filterTypeCase = 7;
            copy._filterTypeValue = PromotionBundleConfig_Filter_GoldPassFilter.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.goldPassFilter.apply(type, path.slice(1), value);
          if (newValue === this.goldPassFilter) {
            return this;
          }
          const copy = new PromotionBundleConfig_Filter(this);
          copy._filterTypeCase = 7;
          copy._filterTypeValue = newValue;
          return copy;
        }
      }
      case "bundlePurchaseHistoryFilter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfig_Filter(this);
              copy._filterTypeCase = 8;
              copy._filterTypeValue = PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._filterTypeCase !== 8) {
                return this;
              }
              const copy = new PromotionBundleConfig_Filter(this);
              copy._filterTypeCase = 0;
              copy._filterTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._filterTypeCase !== 8) {
            const copy = new PromotionBundleConfig_Filter(this);
            copy._filterTypeCase = 8;
            copy._filterTypeValue = PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.bundlePurchaseHistoryFilter.apply(type, path.slice(1), value);
          if (newValue === this.bundlePurchaseHistoryFilter) {
            return this;
          }
          const copy = new PromotionBundleConfig_Filter(this);
          copy._filterTypeCase = 8;
          copy._filterTypeValue = newValue;
          return copy;
        }
      }
      case "operation": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfig_Filter(this);
              copy._hasOperation = true;
              copy._operation = PromotionBundleConfig_Filter_Operation.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOperation) {
                return this;
              }
              const copy = new PromotionBundleConfig_Filter(this);
              copy._hasOperation = false;
              copy._operation = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PromotionBundleConfig_Filter} other
   * @returns {PromotionBundleConfig_Filter}
   */
  merge(other) {
    const copy = new PromotionBundleConfig_Filter(this);
    if (other._filterTypeCase === 1) {
      if (this._filterTypeCase === 1) {
        copy._filterTypeValue = copy._filterTypeValue.merge(other._filterTypeValue);
      } else {
        copy._filterTypeValue = other._filterTypeValue;
      }
      copy._filterTypeCase = 1;
    }
    if (other._filterTypeCase === 1) {
      if (this._filterTypeCase === 1) {
        copy._filterTypeValue = copy._filterTypeValue.merge(other._filterTypeValue);
      } else {
        copy._filterTypeValue = other._filterTypeValue;
      }
      copy._filterTypeCase = 1;
    }
    if (other._filterTypeCase === 1) {
      if (this._filterTypeCase === 1) {
        copy._filterTypeValue = copy._filterTypeValue.merge(other._filterTypeValue);
      } else {
        copy._filterTypeValue = other._filterTypeValue;
      }
      copy._filterTypeCase = 1;
    }
    if (other._filterTypeCase === 1) {
      if (this._filterTypeCase === 1) {
        copy._filterTypeValue = copy._filterTypeValue.merge(other._filterTypeValue);
      } else {
        copy._filterTypeValue = other._filterTypeValue;
      }
      copy._filterTypeCase = 1;
    }
    if (other._filterTypeCase === 1) {
      if (this._filterTypeCase === 1) {
        copy._filterTypeValue = copy._filterTypeValue.merge(other._filterTypeValue);
      } else {
        copy._filterTypeValue = other._filterTypeValue;
      }
      copy._filterTypeCase = 1;
    }
    if (other._filterTypeCase === 1) {
      if (this._filterTypeCase === 1) {
        copy._filterTypeValue = copy._filterTypeValue.merge(other._filterTypeValue);
      } else {
        copy._filterTypeValue = other._filterTypeValue;
      }
      copy._filterTypeCase = 1;
    }
    if (other._filterTypeCase === 1) {
      if (this._filterTypeCase === 1) {
        copy._filterTypeValue = copy._filterTypeValue.merge(other._filterTypeValue);
      } else {
        copy._filterTypeValue = other._filterTypeValue;
      }
      copy._filterTypeCase = 1;
    }
    if (other._filterTypeCase === 1) {
      if (this._filterTypeCase === 1) {
        copy._filterTypeValue = copy._filterTypeValue.merge(other._filterTypeValue);
      } else {
        copy._filterTypeValue = other._filterTypeValue;
      }
      copy._filterTypeCase = 1;
    }
    if (other._hasOperation) {
      copy._hasOperation = true;
      copy._operation = other._operation;
    }
    return copy;
  }
}
PromotionBundleConfig_Filter.default = new PromotionBundleConfig_Filter();
PromotionBundleConfig_Filter.DateFilter = PromotionBundleConfig_Filter_DateFilter;
PromotionBundleConfig_Filter.DailyProgressFilter = PromotionBundleConfig_Filter_DailyProgressFilter;
PromotionBundleConfig_Filter.PlayerLevelFilter = PromotionBundleConfig_Filter_PlayerLevelFilter;
PromotionBundleConfig_Filter.PlayerUuidFilter = PromotionBundleConfig_Filter_PlayerUuidFilter;
PromotionBundleConfig_Filter.CampaignProgressFilter = PromotionBundleConfig_Filter_CampaignProgressFilter;
PromotionBundleConfig_Filter.CardSubscriptionFilter = PromotionBundleConfig_Filter_CardSubscriptionFilter;
PromotionBundleConfig_Filter.GoldPassFilter = PromotionBundleConfig_Filter_GoldPassFilter;
PromotionBundleConfig_Filter.BundlePurchaseHistoryFilter = PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter;
PromotionBundleConfig_Filter.Operation = PromotionBundleConfig_Filter_Operation;
class PromotionBundleConfig_Filter_Builder {
  constructor(value) {
    this._value = new PromotionBundleConfig_Filter(value);
  }
  build() {
    return new PromotionBundleConfig_Filter(this._value);
  }
  clearfilterType() {
    this._value._filterTypeCase = 0;
    this._value._filterTypeValue = null;
    return this;
  }
  setDateFilter(value) {
    this._value._filterTypeCase = 1;
    this._value._filterTypeValue = value;
    return this;
  }
  setDailyProgressFilter(value) {
    this._value._filterTypeCase = 2;
    this._value._filterTypeValue = value;
    return this;
  }
  setPlayerLevelFilter(value) {
    this._value._filterTypeCase = 3;
    this._value._filterTypeValue = value;
    return this;
  }
  setPlayerUuidFilter(value) {
    this._value._filterTypeCase = 4;
    this._value._filterTypeValue = value;
    return this;
  }
  setCampaignProgressFilter(value) {
    this._value._filterTypeCase = 5;
    this._value._filterTypeValue = value;
    return this;
  }
  setCardSubscriptionFilter(value) {
    this._value._filterTypeCase = 6;
    this._value._filterTypeValue = value;
    return this;
  }
  setGoldPassFilter(value) {
    this._value._filterTypeCase = 7;
    this._value._filterTypeValue = value;
    return this;
  }
  setBundlePurchaseHistoryFilter(value) {
    this._value._filterTypeCase = 8;
    this._value._filterTypeValue = value;
    return this;
  }
  setOperation(value) {
    this._value._hasOperation = true;
    this._value._operation = value;
    return this;
  }
  deleteOperation() {
    this._value._hasOperation = false;
    this._value._operation = null;
    return this;
  }
}
PromotionBundleConfig_Filter.Builder = PromotionBundleConfig_Filter_Builder;
class PromotionBundleConfig_Filter_WithParent {
  /**
   * @param {PromotionBundleConfig_Filter} value
   * @param {PromotionBundleConfig_Filter_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PromotionBundleConfig_Filter.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get filterTypeCase() {
    if (this._cachedfilterTypeCase === undefined) {
      if (this._value._filterTypeCase === 0) {
        this._cachedfilterTypeCase = this._parent ? this._parent.filterTypeCase : 0;
      } else {
        this._cachedfilterTypeCase = this._value._filterTypeCase;
      }
    }
    return this._cachedfilterTypeCase;
  }
  get dateFilter() {
    if (!this._cachedDateFilter) {
      if (this._value._filterTypeCase === 0) {
        this._cachedDateFilter = this._parent ? new PromotionBundleConfig_Filter_DateFilter.WithParent(PromotionBundleConfig_Filter_DateFilter.default, this._parent.dateFilter) : this._value.dateFilter;
      } else if (this._value._filterTypeCase === 1) {
        this._cachedDateFilter = new PromotionBundleConfig_Filter_DateFilter.WithParent(this._value.dateFilter, this._parent && this._parent.filterTypeCase === 1 ? this._parent.dateFilter : null);
      } else {
        this._cachedDateFilter = PromotionBundleConfig_Filter_DateFilter.WithParent.default;
      }
    }
    return this._cachedDateFilter;
  }
  get dailyProgressFilter() {
    if (!this._cachedDailyProgressFilter) {
      if (this._value._filterTypeCase === 0) {
        this._cachedDailyProgressFilter = this._parent ? new PromotionBundleConfig_Filter_DailyProgressFilter.WithParent(PromotionBundleConfig_Filter_DailyProgressFilter.default, this._parent.dailyProgressFilter) : this._value.dailyProgressFilter;
      } else if (this._value._filterTypeCase === 2) {
        this._cachedDailyProgressFilter = new PromotionBundleConfig_Filter_DailyProgressFilter.WithParent(this._value.dailyProgressFilter, this._parent && this._parent.filterTypeCase === 2 ? this._parent.dailyProgressFilter : null);
      } else {
        this._cachedDailyProgressFilter = PromotionBundleConfig_Filter_DailyProgressFilter.WithParent.default;
      }
    }
    return this._cachedDailyProgressFilter;
  }
  get playerLevelFilter() {
    if (!this._cachedPlayerLevelFilter) {
      if (this._value._filterTypeCase === 0) {
        this._cachedPlayerLevelFilter = this._parent ? new PromotionBundleConfig_Filter_PlayerLevelFilter.WithParent(PromotionBundleConfig_Filter_PlayerLevelFilter.default, this._parent.playerLevelFilter) : this._value.playerLevelFilter;
      } else if (this._value._filterTypeCase === 3) {
        this._cachedPlayerLevelFilter = new PromotionBundleConfig_Filter_PlayerLevelFilter.WithParent(this._value.playerLevelFilter, this._parent && this._parent.filterTypeCase === 3 ? this._parent.playerLevelFilter : null);
      } else {
        this._cachedPlayerLevelFilter = PromotionBundleConfig_Filter_PlayerLevelFilter.WithParent.default;
      }
    }
    return this._cachedPlayerLevelFilter;
  }
  get playerUuidFilter() {
    if (!this._cachedPlayerUuidFilter) {
      if (this._value._filterTypeCase === 0) {
        this._cachedPlayerUuidFilter = this._parent ? new PromotionBundleConfig_Filter_PlayerUuidFilter.WithParent(PromotionBundleConfig_Filter_PlayerUuidFilter.default, this._parent.playerUuidFilter) : this._value.playerUuidFilter;
      } else if (this._value._filterTypeCase === 4) {
        this._cachedPlayerUuidFilter = new PromotionBundleConfig_Filter_PlayerUuidFilter.WithParent(this._value.playerUuidFilter, this._parent && this._parent.filterTypeCase === 4 ? this._parent.playerUuidFilter : null);
      } else {
        this._cachedPlayerUuidFilter = PromotionBundleConfig_Filter_PlayerUuidFilter.WithParent.default;
      }
    }
    return this._cachedPlayerUuidFilter;
  }
  get campaignProgressFilter() {
    if (!this._cachedCampaignProgressFilter) {
      if (this._value._filterTypeCase === 0) {
        this._cachedCampaignProgressFilter = this._parent ? new PromotionBundleConfig_Filter_CampaignProgressFilter.WithParent(PromotionBundleConfig_Filter_CampaignProgressFilter.default, this._parent.campaignProgressFilter) : this._value.campaignProgressFilter;
      } else if (this._value._filterTypeCase === 5) {
        this._cachedCampaignProgressFilter = new PromotionBundleConfig_Filter_CampaignProgressFilter.WithParent(this._value.campaignProgressFilter, this._parent && this._parent.filterTypeCase === 5 ? this._parent.campaignProgressFilter : null);
      } else {
        this._cachedCampaignProgressFilter = PromotionBundleConfig_Filter_CampaignProgressFilter.WithParent.default;
      }
    }
    return this._cachedCampaignProgressFilter;
  }
  get cardSubscriptionFilter() {
    if (!this._cachedCardSubscriptionFilter) {
      if (this._value._filterTypeCase === 0) {
        this._cachedCardSubscriptionFilter = this._parent ? new PromotionBundleConfig_Filter_CardSubscriptionFilter.WithParent(PromotionBundleConfig_Filter_CardSubscriptionFilter.default, this._parent.cardSubscriptionFilter) : this._value.cardSubscriptionFilter;
      } else if (this._value._filterTypeCase === 6) {
        this._cachedCardSubscriptionFilter = new PromotionBundleConfig_Filter_CardSubscriptionFilter.WithParent(this._value.cardSubscriptionFilter, this._parent && this._parent.filterTypeCase === 6 ? this._parent.cardSubscriptionFilter : null);
      } else {
        this._cachedCardSubscriptionFilter = PromotionBundleConfig_Filter_CardSubscriptionFilter.WithParent.default;
      }
    }
    return this._cachedCardSubscriptionFilter;
  }
  get goldPassFilter() {
    if (!this._cachedGoldPassFilter) {
      if (this._value._filterTypeCase === 0) {
        this._cachedGoldPassFilter = this._parent ? new PromotionBundleConfig_Filter_GoldPassFilter.WithParent(PromotionBundleConfig_Filter_GoldPassFilter.default, this._parent.goldPassFilter) : this._value.goldPassFilter;
      } else if (this._value._filterTypeCase === 7) {
        this._cachedGoldPassFilter = new PromotionBundleConfig_Filter_GoldPassFilter.WithParent(this._value.goldPassFilter, this._parent && this._parent.filterTypeCase === 7 ? this._parent.goldPassFilter : null);
      } else {
        this._cachedGoldPassFilter = PromotionBundleConfig_Filter_GoldPassFilter.WithParent.default;
      }
    }
    return this._cachedGoldPassFilter;
  }
  get bundlePurchaseHistoryFilter() {
    if (!this._cachedBundlePurchaseHistoryFilter) {
      if (this._value._filterTypeCase === 0) {
        this._cachedBundlePurchaseHistoryFilter = this._parent ? new PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter.WithParent(PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter.default, this._parent.bundlePurchaseHistoryFilter) : this._value.bundlePurchaseHistoryFilter;
      } else if (this._value._filterTypeCase === 8) {
        this._cachedBundlePurchaseHistoryFilter = new PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter.WithParent(this._value.bundlePurchaseHistoryFilter, this._parent && this._parent.filterTypeCase === 8 ? this._parent.bundlePurchaseHistoryFilter : null);
      } else {
        this._cachedBundlePurchaseHistoryFilter = PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter.WithParent.default;
      }
    }
    return this._cachedBundlePurchaseHistoryFilter;
  }
  get hasOperation() {
    if (this._cachedHasOperation === undefined) {
      if (this._value.hasOperation) {
        this._cachedHasOperation = true;
      } else {
        this._cachedHasOperation = this._parent ? this._parent.hasOperation : false;
      }
    }
    return this._cachedHasOperation;
  }
  get operation() {
    if (this._cachedOperation === undefined) {
      if (this._value.hasOperation) {
        this._cachedOperation = this._value.operation;
      } else {
        this._cachedOperation = this._parent ? this._parent.operation : this._value.operation;
      }
    }
    return this._cachedOperation;
  }
  update(current, parent) {
    const result = new PromotionBundleConfig_Filter_WithParent(current, parent);
    if (this._cachedDateFilter && this._value._filterTypeCase === 1 && current._filterTypeCase === 1) {
      if (this._value.dateFilter === current.dateFilter && this._parent === parent) {
        result._cachedDateFilter = this._cachedDateFilter;
      } else {
        result._cachedDateFilter = this._cachedDateFilter.update(current.dateFilter, parent && parent.filterTypeCase === 1 ? parent.dateFilter : null);
      }
    }
    if (this._cachedDailyProgressFilter && this._value._filterTypeCase === 2 && current._filterTypeCase === 2) {
      if (this._value.dailyProgressFilter === current.dailyProgressFilter && this._parent === parent) {
        result._cachedDailyProgressFilter = this._cachedDailyProgressFilter;
      } else {
        result._cachedDailyProgressFilter = this._cachedDailyProgressFilter.update(current.dailyProgressFilter, parent && parent.filterTypeCase === 2 ? parent.dailyProgressFilter : null);
      }
    }
    if (this._cachedPlayerLevelFilter && this._value._filterTypeCase === 3 && current._filterTypeCase === 3) {
      if (this._value.playerLevelFilter === current.playerLevelFilter && this._parent === parent) {
        result._cachedPlayerLevelFilter = this._cachedPlayerLevelFilter;
      } else {
        result._cachedPlayerLevelFilter = this._cachedPlayerLevelFilter.update(current.playerLevelFilter, parent && parent.filterTypeCase === 3 ? parent.playerLevelFilter : null);
      }
    }
    if (this._cachedPlayerUuidFilter && this._value._filterTypeCase === 4 && current._filterTypeCase === 4) {
      if (this._value.playerUuidFilter === current.playerUuidFilter && this._parent === parent) {
        result._cachedPlayerUuidFilter = this._cachedPlayerUuidFilter;
      } else {
        result._cachedPlayerUuidFilter = this._cachedPlayerUuidFilter.update(current.playerUuidFilter, parent && parent.filterTypeCase === 4 ? parent.playerUuidFilter : null);
      }
    }
    if (this._cachedCampaignProgressFilter && this._value._filterTypeCase === 5 && current._filterTypeCase === 5) {
      if (this._value.campaignProgressFilter === current.campaignProgressFilter && this._parent === parent) {
        result._cachedCampaignProgressFilter = this._cachedCampaignProgressFilter;
      } else {
        result._cachedCampaignProgressFilter = this._cachedCampaignProgressFilter.update(current.campaignProgressFilter, parent && parent.filterTypeCase === 5 ? parent.campaignProgressFilter : null);
      }
    }
    if (this._cachedCardSubscriptionFilter && this._value._filterTypeCase === 6 && current._filterTypeCase === 6) {
      if (this._value.cardSubscriptionFilter === current.cardSubscriptionFilter && this._parent === parent) {
        result._cachedCardSubscriptionFilter = this._cachedCardSubscriptionFilter;
      } else {
        result._cachedCardSubscriptionFilter = this._cachedCardSubscriptionFilter.update(current.cardSubscriptionFilter, parent && parent.filterTypeCase === 6 ? parent.cardSubscriptionFilter : null);
      }
    }
    if (this._cachedGoldPassFilter && this._value._filterTypeCase === 7 && current._filterTypeCase === 7) {
      if (this._value.goldPassFilter === current.goldPassFilter && this._parent === parent) {
        result._cachedGoldPassFilter = this._cachedGoldPassFilter;
      } else {
        result._cachedGoldPassFilter = this._cachedGoldPassFilter.update(current.goldPassFilter, parent && parent.filterTypeCase === 7 ? parent.goldPassFilter : null);
      }
    }
    if (this._cachedBundlePurchaseHistoryFilter && this._value._filterTypeCase === 8 && current._filterTypeCase === 8) {
      if (this._value.bundlePurchaseHistoryFilter === current.bundlePurchaseHistoryFilter && this._parent === parent) {
        result._cachedBundlePurchaseHistoryFilter = this._cachedBundlePurchaseHistoryFilter;
      } else {
        result._cachedBundlePurchaseHistoryFilter = this._cachedBundlePurchaseHistoryFilter.update(current.bundlePurchaseHistoryFilter, parent && parent.filterTypeCase === 8 ? parent.bundlePurchaseHistoryFilter : null);
      }
    }
    return result;
  }
}
PromotionBundleConfig_Filter_WithParent.default = new PromotionBundleConfig_Filter_WithParent(PromotionBundleConfig_Filter.default, null);
PromotionBundleConfig_Filter.WithParent = PromotionBundleConfig_Filter_WithParent;
class PromotionBundleConfig_Filter_Descriptor {
  get dateFilter() {
    if (!this._dateFilter) {
      this._dateFilter = {
        name: "dateFilter",
        Name: "DateFilter",
        number: 1,
        protoType: 11,
        protoName: "date_filter",
        oneofIndex: 0,
        type: PromotionBundleConfig_Filter_DateFilter,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dateFilter;
  }
  get dailyProgressFilter() {
    if (!this._dailyProgressFilter) {
      this._dailyProgressFilter = {
        name: "dailyProgressFilter",
        Name: "DailyProgressFilter",
        number: 2,
        protoType: 11,
        protoName: "daily_progress_filter",
        oneofIndex: 0,
        type: PromotionBundleConfig_Filter_DailyProgressFilter,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dailyProgressFilter;
  }
  get playerLevelFilter() {
    if (!this._playerLevelFilter) {
      this._playerLevelFilter = {
        name: "playerLevelFilter",
        Name: "PlayerLevelFilter",
        number: 3,
        protoType: 11,
        protoName: "player_level_filter",
        oneofIndex: 0,
        type: PromotionBundleConfig_Filter_PlayerLevelFilter,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerLevelFilter;
  }
  get playerUuidFilter() {
    if (!this._playerUuidFilter) {
      this._playerUuidFilter = {
        name: "playerUuidFilter",
        Name: "PlayerUuidFilter",
        number: 4,
        protoType: 11,
        protoName: "player_uuid_filter",
        oneofIndex: 0,
        type: PromotionBundleConfig_Filter_PlayerUuidFilter,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerUuidFilter;
  }
  get campaignProgressFilter() {
    if (!this._campaignProgressFilter) {
      this._campaignProgressFilter = {
        name: "campaignProgressFilter",
        Name: "CampaignProgressFilter",
        number: 5,
        protoType: 11,
        protoName: "campaign_progress_filter",
        oneofIndex: 0,
        type: PromotionBundleConfig_Filter_CampaignProgressFilter,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._campaignProgressFilter;
  }
  get cardSubscriptionFilter() {
    if (!this._cardSubscriptionFilter) {
      this._cardSubscriptionFilter = {
        name: "cardSubscriptionFilter",
        Name: "CardSubscriptionFilter",
        number: 6,
        protoType: 11,
        protoName: "card_subscription_filter",
        oneofIndex: 0,
        type: PromotionBundleConfig_Filter_CardSubscriptionFilter,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardSubscriptionFilter;
  }
  get goldPassFilter() {
    if (!this._goldPassFilter) {
      this._goldPassFilter = {
        name: "goldPassFilter",
        Name: "GoldPassFilter",
        number: 7,
        protoType: 11,
        protoName: "gold_pass_filter",
        oneofIndex: 0,
        type: PromotionBundleConfig_Filter_GoldPassFilter,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._goldPassFilter;
  }
  get bundlePurchaseHistoryFilter() {
    if (!this._bundlePurchaseHistoryFilter) {
      this._bundlePurchaseHistoryFilter = {
        name: "bundlePurchaseHistoryFilter",
        Name: "BundlePurchaseHistoryFilter",
        number: 8,
        protoType: 11,
        protoName: "bundle_purchase_history_filter",
        oneofIndex: 0,
        type: PromotionBundleConfig_Filter_BundlePurchaseHistoryFilter,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._bundlePurchaseHistoryFilter;
  }
  get operation() {
    if (!this._operation) {
      this._operation = {
        name: "operation",
        Name: "Operation",
        number: 11,
        protoType: 14,
        protoName: "operation",
        type: PromotionBundleConfig_Filter_Operation,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._operation;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.dateFilter,
        this.dailyProgressFilter,
        this.playerLevelFilter,
        this.playerUuidFilter,
        this.campaignProgressFilter,
        this.cardSubscriptionFilter,
        this.goldPassFilter,
        this.bundlePurchaseHistoryFilter,
        this.operation,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "filterType",
        Name: "FilterType",
        fields: [
          this.fields[0],
          this.fields[1],
          this.fields[2],
          this.fields[3],
          this.fields[4],
          this.fields[5],
          this.fields[6],
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForOperation",
        Name: "DummyOneofForOperation",
        fields: [
          this.fields[8],
        ],
      });
    }
    return this._oneofs;
  }
}
PromotionBundleConfig_Filter.descriptor = new PromotionBundleConfig_Filter_Descriptor();
export class PromotionBundleConfig {
  get descriptor() {
    return PromotionBundleConfig.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._bundleIds = [];
    this._hasCardPortrait = false;
    this._cardPortrait = null;
    this._hasBackground = false;
    this._background = null;
    this._filters = [];
    this._hasEnable = false;
    this._enable = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._bundleIds.length > 0) return false;
    if (this._hasCardPortrait) return false;
    if (this._hasBackground) return false;
    if (this._filters.length > 0) return false;
    if (this._hasEnable) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PromotionBundleConfig) {
      return value;
    }
    return PromotionBundleConfig.fromJson(value);
  }
  static fromJson(json) {
    const result = new PromotionBundleConfig();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    result._bundleIds = JsonToList(json.bundleIds, JsonToString);
    if (json.cardPortrait != null) {
      result._hasCardPortrait = true;
      result._cardPortrait = JsonToString.fromJson(json.cardPortrait);
    }
    if (json.background != null) {
      result._hasBackground = true;
      result._background = JsonToString.fromJson(json.background);
    }
    result._filters = JsonToList(json.filters, PromotionBundleConfig_Filter);
    if (json.enable != null) {
      result._hasEnable = true;
      result._enable = JsonToBoolean.fromJson(json.enable);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._bundleIds.length > 0) {
      result.bundleIds = ArrayToJson(this._bundleIds, JsonToString);
    }
    if (this._hasCardPortrait) {
      result.cardPortrait = JsonToString.toJson(this._cardPortrait);
    }
    if (this._hasBackground) {
      result.background = JsonToString.toJson(this._background);
    }
    if (this._filters.length > 0) {
      result.filters = ArrayToJson(this._filters, PromotionBundleConfig_Filter);
    }
    if (this._hasEnable) {
      result.enable = JsonToBoolean.toJson(this._enable);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {string[]}
   */
  get bundleIds() {
    return this._bundleIds;
  }
  addBundleIds(path, value) {
    return {type: 'ADD', path: path.concat(['bundleIds']), value};
  }
  setBundleIds(path, value) {
    return {type: 'SET', path: path.concat(['bundleIds']), value: ArrayToJson(value, JsonToString)};
  }
  setBundleIdsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['bundleIds', key]), value};
  }
  deleteBundleIds(path) {
    return {type: 'DELETE', path: path.concat(['bundleIds'])};
  }
  deleteBundleIdsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['bundleIds', key])};
  }
  /**
   * @returns {string}
   */
  get cardPortrait() {
    return this._hasCardPortrait ? this._cardPortrait : JsonToString.default;
  }
  get hasCardPortrait() {
    return this._hasCardPortrait;
  }
  setCardPortrait(path, value) {
    return {type: 'SET', path: path.concat(['cardPortrait']), value};
  }
  deleteCardPortrait(path) {
    return {type: 'DELETE', path: path.concat(['cardPortrait'])};
  }
  /**
   * @returns {string}
   */
  get background() {
    return this._hasBackground ? this._background : JsonToString.default;
  }
  get hasBackground() {
    return this._hasBackground;
  }
  setBackground(path, value) {
    return {type: 'SET', path: path.concat(['background']), value};
  }
  deleteBackground(path) {
    return {type: 'DELETE', path: path.concat(['background'])};
  }
  /**
   * @returns {PromotionBundleConfig_Filter[]}
   */
  get filters() {
    return this._filters;
  }
  addFilters(path, value) {
    return {type: 'ADD', path: path.concat(['filters']), value: value.toJson()};
  }
  setFilters(path, value) {
    return {type: 'SET', path: path.concat(['filters']), value: ArrayToJson(value, PromotionBundleConfig_Filter)};
  }
  setFiltersByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['filters', key]), value: value.toJson()};
  }
  deleteFilters(path) {
    return {type: 'DELETE', path: path.concat(['filters'])};
  }
  deleteFiltersByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['filters', key])};
  }
  /**
   * @returns {boolean}
   */
  get enable() {
    return this._hasEnable ? this._enable : JsonToBoolean.default;
  }
  get hasEnable() {
    return this._hasEnable;
  }
  setEnable(path, value) {
    return {type: 'SET', path: path.concat(['enable']), value};
  }
  deleteEnable(path) {
    return {type: 'DELETE', path: path.concat(['enable'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfig(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new PromotionBundleConfig(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "bundleIds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfig(this);
              copy._bundleIds = [];        for (let i of value) {
                copy._bundleIds.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new PromotionBundleConfig(this);
              copy._bundleIds = copy._bundleIds.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._bundleIds.length === 0) {
                return this;
              }
              const copy = new PromotionBundleConfig(this);
              copy._bundleIds = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._bundleIds.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfig(this);
              copy._bundleIds = copy._bundleIds.slice();
              copy._bundleIds[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new PromotionBundleConfig(this);
              copy._bundleIds = copy._bundleIds.slice(0, path[1]).concat(copy._bundleIds.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._bundleIds.length) {
            return this;
          }
          const oldValue = this._bundleIds[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new PromotionBundleConfig(this);
          copy._bundleIds = copy._bundleIds.slice();
          copy._bundleIds[key] = newValue;
          return copy;
        }
      }
      case "cardPortrait": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfig(this);
              copy._hasCardPortrait = true;
              copy._cardPortrait = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardPortrait) {
                return this;
              }
              const copy = new PromotionBundleConfig(this);
              copy._hasCardPortrait = false;
              copy._cardPortrait = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "background": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfig(this);
              copy._hasBackground = true;
              copy._background = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBackground) {
                return this;
              }
              const copy = new PromotionBundleConfig(this);
              copy._hasBackground = false;
              copy._background = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "filters": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfig(this);
              copy._filters = [];        for (let i of value) {
                copy._filters.push(PromotionBundleConfig_Filter.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new PromotionBundleConfig(this);
              copy._filters = copy._filters.concat([PromotionBundleConfig_Filter.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._filters.length === 0) {
                return this;
              }
              const copy = new PromotionBundleConfig(this);
              copy._filters = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._filters.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfig(this);
              copy._filters = copy._filters.slice();
              copy._filters[path[1]] = PromotionBundleConfig_Filter.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new PromotionBundleConfig(this);
              copy._filters = copy._filters.slice(0, path[1]).concat(copy._filters.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._filters.length) {
            return this;
          }
          const oldValue = this._filters[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new PromotionBundleConfig(this);
          copy._filters = copy._filters.slice();
          copy._filters[key] = newValue;
          return copy;
        }
      }
      case "enable": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfig(this);
              copy._hasEnable = true;
              copy._enable = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEnable) {
                return this;
              }
              const copy = new PromotionBundleConfig(this);
              copy._hasEnable = false;
              copy._enable = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PromotionBundleConfig} other
   * @returns {PromotionBundleConfig}
   */
  merge(other) {
    const copy = new PromotionBundleConfig(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    copy._bundleIds = this._bundleIds.concat(other._bundleIds);
    if (other._hasCardPortrait) {
      copy._hasCardPortrait = true;
      copy._cardPortrait = other._cardPortrait;
    }
    if (other._hasBackground) {
      copy._hasBackground = true;
      copy._background = other._background;
    }
    copy._filters = this._filters.concat(other._filters);
    if (other._hasEnable) {
      copy._hasEnable = true;
      copy._enable = other._enable;
    }
    return copy;
  }
}
PromotionBundleConfig.default = new PromotionBundleConfig();
PromotionBundleConfig.Filter = PromotionBundleConfig_Filter;
class PromotionBundleConfig_Builder {
  constructor(value) {
    this._value = new PromotionBundleConfig(value);
  }
  build() {
    return new PromotionBundleConfig(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  addAllBundleIds(values) {
    this._value._bundleIds = this._value._bundleIds.concat(values);
    return this;
  }
  addBundleIds(value) {
    this._value._bundleIds = this._value._bundleIds.concat([value]);
    return this;
  }
  setBundleIds(index, value) {
    this._value._bundleIds = this._value._bundleIds.concat();
    this._value._bundleIds[index] = value;
    return this;
  }
  clearBundleIds() {
    this._value._bundleIds = [];
    return this;
  }
  setCardPortrait(value) {
    this._value._hasCardPortrait = true;
    this._value._cardPortrait = value;
    return this;
  }
  deleteCardPortrait() {
    this._value._hasCardPortrait = false;
    this._value._cardPortrait = null;
    return this;
  }
  setBackground(value) {
    this._value._hasBackground = true;
    this._value._background = value;
    return this;
  }
  deleteBackground() {
    this._value._hasBackground = false;
    this._value._background = null;
    return this;
  }
  addAllFilters(values) {
    this._value._filters = this._value._filters.concat(values);
    return this;
  }
  addFilters(value) {
    this._value._filters = this._value._filters.concat([value]);
    return this;
  }
  setFilters(index, value) {
    this._value._filters = this._value._filters.concat();
    this._value._filters[index] = value;
    return this;
  }
  clearFilters() {
    this._value._filters = [];
    return this;
  }
  setEnable(value) {
    this._value._hasEnable = true;
    this._value._enable = value;
    return this;
  }
  deleteEnable() {
    this._value._hasEnable = false;
    this._value._enable = null;
    return this;
  }
}
PromotionBundleConfig.Builder = PromotionBundleConfig_Builder;
class PromotionBundleConfig_WithParent {
  /**
   * @param {PromotionBundleConfig} value
   * @param {PromotionBundleConfig_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PromotionBundleConfig.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get selfBundleIds() {
    return this._value.bundleIds;
  }
  get inherentBundleIds() {
    if (!this._inherentBundleIds) {
      this._inherentBundleIds = this._parent ? this._parent.bundleIds : [];
    }
    return this._inherentBundleIds;
  }
  get bundleIds() {
    if (!this._allBundleIds) {
      this._allBundleIds = this._parent ? this._parent.bundleIds.concat(this.selfBundleIds) : this.selfBundleIds;
    }
    return this._allBundleIds;
  }
  get hasCardPortrait() {
    if (this._cachedHasCardPortrait === undefined) {
      if (this._value.hasCardPortrait) {
        this._cachedHasCardPortrait = true;
      } else {
        this._cachedHasCardPortrait = this._parent ? this._parent.hasCardPortrait : false;
      }
    }
    return this._cachedHasCardPortrait;
  }
  get cardPortrait() {
    if (this._cachedCardPortrait === undefined) {
      if (this._value.hasCardPortrait) {
        this._cachedCardPortrait = this._value.cardPortrait;
      } else {
        this._cachedCardPortrait = this._parent ? this._parent.cardPortrait : this._value.cardPortrait;
      }
    }
    return this._cachedCardPortrait;
  }
  get hasBackground() {
    if (this._cachedHasBackground === undefined) {
      if (this._value.hasBackground) {
        this._cachedHasBackground = true;
      } else {
        this._cachedHasBackground = this._parent ? this._parent.hasBackground : false;
      }
    }
    return this._cachedHasBackground;
  }
  get background() {
    if (this._cachedBackground === undefined) {
      if (this._value.hasBackground) {
        this._cachedBackground = this._value.background;
      } else {
        this._cachedBackground = this._parent ? this._parent.background : this._value.background;
      }
    }
    return this._cachedBackground;
  }
  get selfFilters() {
    if (!this._selfFilters) {
      this._selfFilters = [];
      for (let i of this._value.filters) {
        this._selfFilters.push(new PromotionBundleConfig_Filter.WithParent(i, null));
      }
    }
    return this._selfFilters;
  }
  get inherentFilters() {
    if (!this._inherentFilters) {
      this._inherentFilters = this._parent ? this._parent.filters : [];
    }
    return this._inherentFilters;
  }
  get filters() {
    if (!this._allFilters) {
      this._allFilters = this._parent ? this._parent.filters.concat(this.selfFilters) : this.selfFilters;
    }
    return this._allFilters;
  }
  get hasEnable() {
    if (this._cachedHasEnable === undefined) {
      if (this._value.hasEnable) {
        this._cachedHasEnable = true;
      } else {
        this._cachedHasEnable = this._parent ? this._parent.hasEnable : false;
      }
    }
    return this._cachedHasEnable;
  }
  get enable() {
    if (this._cachedEnable === undefined) {
      if (this._value.hasEnable) {
        this._cachedEnable = this._value.enable;
      } else {
        this._cachedEnable = this._parent ? this._parent.enable : this._value.enable;
      }
    }
    return this._cachedEnable;
  }
  update(current, parent) {
    const result = new PromotionBundleConfig_WithParent(current, parent);
    if (this._selfFilters) {
      if (this._value.filters === current.filters) {
        result._selfFilters = this._selfFilters;
      } else {
        result._selfFilters = [];
        for (let i = 0; i < current.filters.length; i++) {
          const oldValue = this._value.filters[i];
          if (oldValue) {
            const oldCache = this._selfFilters[i];
            if (oldValue === current.filters[i]) {
              result._selfFilters[i] = oldCache;
            } else {
              result._selfFilters[i] = oldCache.update(current.filters[i], null);
            }
          } else {
            result._selfFilters[i] = new PromotionBundleConfig_Filter.WithParent(current.filters[i], null);
          }
        }
      }
    }
    return result;
  }
}
PromotionBundleConfig_WithParent.default = new PromotionBundleConfig_WithParent(PromotionBundleConfig.default, null);
PromotionBundleConfig.WithParent = PromotionBundleConfig_WithParent;
class PromotionBundleConfig_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get bundleIds() {
    if (!this._bundleIds) {
      this._bundleIds = {
        name: "bundleIds",
        Name: "BundleIds",
        number: 2,
        protoType: 9,
        protoName: "bundle_ids",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "IapBundleList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._bundleIds;
  }
  get cardPortrait() {
    if (!this._cardPortrait) {
      this._cardPortrait = {
        name: "cardPortrait",
        Name: "CardPortrait",
        number: 3,
        protoType: 9,
        protoName: "card_portrait",
        type: JsonToString,
        options: {
          valueDropdown: "ShowcaseCardPortraits",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardPortrait;
  }
  get background() {
    if (!this._background) {
      this._background = {
        name: "background",
        Name: "Background",
        number: 4,
        protoType: 9,
        protoName: "background",
        type: JsonToString,
        options: {
          valueDropdown: "BundlePopUpBackgrounds",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._background;
  }
  get filters() {
    if (!this._filters) {
      this._filters = {
        name: "filters",
        Name: "Filters",
        number: 5,
        protoType: 11,
        protoName: "filters",
        type: PromotionBundleConfig_Filter,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._filters;
  }
  get enable() {
    if (!this._enable) {
      this._enable = {
        name: "enable",
        Name: "Enable",
        number: 6,
        protoType: 8,
        protoName: "enable",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._enable;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.bundleIds,
        this.cardPortrait,
        this.background,
        this.filters,
        this.enable,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCardPortrait",
        Name: "DummyOneofForCardPortrait",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBackground",
        Name: "DummyOneofForBackground",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEnable",
        Name: "DummyOneofForEnable",
        fields: [
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
PromotionBundleConfig.descriptor = new PromotionBundleConfig_Descriptor();
export class PromotionBundleConfigs {
  get descriptor() {
    return PromotionBundleConfigs.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._promotionBundleConfigs = [];
  }
  isEmpty() {
    if (this._promotionBundleConfigs.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PromotionBundleConfigs) {
      return value;
    }
    return PromotionBundleConfigs.fromJson(value);
  }
  static fromJson(json) {
    const result = new PromotionBundleConfigs();
    result._promotionBundleConfigs = JsonToList(json.promotionBundleConfigs, PromotionBundleConfig);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._promotionBundleConfigs.length > 0) {
      result.promotionBundleConfigs = ArrayToJson(this._promotionBundleConfigs, PromotionBundleConfig);
    }
    return result;
  }
  /**
   * @returns {PromotionBundleConfig[]}
   */
  get promotionBundleConfigs() {
    return this._promotionBundleConfigs;
  }
  addPromotionBundleConfigs_(path, value) {
    return {type: 'ADD', path: path.concat(['promotionBundleConfigs']), value: value.toJson()};
  }
  setPromotionBundleConfigs_(path, value) {
    return {type: 'SET', path: path.concat(['promotionBundleConfigs']), value: ArrayToJson(value, PromotionBundleConfig)};
  }
  setPromotionBundleConfigs_ByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['promotionBundleConfigs', key]), value: value.toJson()};
  }
  deletePromotionBundleConfigs_(path) {
    return {type: 'DELETE', path: path.concat(['promotionBundleConfigs'])};
  }
  deletePromotionBundleConfigs_ByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['promotionBundleConfigs', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "promotionBundleConfigs": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfigs(this);
              copy._promotionBundleConfigs = [];        for (let i of value) {
                copy._promotionBundleConfigs.push(PromotionBundleConfig.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new PromotionBundleConfigs(this);
              copy._promotionBundleConfigs = copy._promotionBundleConfigs.concat([PromotionBundleConfig.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._promotionBundleConfigs.length === 0) {
                return this;
              }
              const copy = new PromotionBundleConfigs(this);
              copy._promotionBundleConfigs = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._promotionBundleConfigs.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new PromotionBundleConfigs(this);
              copy._promotionBundleConfigs = copy._promotionBundleConfigs.slice();
              copy._promotionBundleConfigs[path[1]] = PromotionBundleConfig.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new PromotionBundleConfigs(this);
              copy._promotionBundleConfigs = copy._promotionBundleConfigs.slice(0, path[1]).concat(copy._promotionBundleConfigs.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._promotionBundleConfigs.length) {
            return this;
          }
          const oldValue = this._promotionBundleConfigs[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new PromotionBundleConfigs(this);
          copy._promotionBundleConfigs = copy._promotionBundleConfigs.slice();
          copy._promotionBundleConfigs[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PromotionBundleConfigs} other
   * @returns {PromotionBundleConfigs}
   */
  merge(other) {
    const copy = new PromotionBundleConfigs(this);
    copy._promotionBundleConfigs = this._promotionBundleConfigs.concat(other._promotionBundleConfigs);
    return copy;
  }
}
PromotionBundleConfigs.default = new PromotionBundleConfigs();
class PromotionBundleConfigs_Builder {
  constructor(value) {
    this._value = new PromotionBundleConfigs(value);
  }
  build() {
    return new PromotionBundleConfigs(this._value);
  }
  addAllPromotionBundleConfigs_(values) {
    this._value._promotionBundleConfigs = this._value._promotionBundleConfigs.concat(values);
    return this;
  }
  addPromotionBundleConfigs_(value) {
    this._value._promotionBundleConfigs = this._value._promotionBundleConfigs.concat([value]);
    return this;
  }
  setPromotionBundleConfigs_(index, value) {
    this._value._promotionBundleConfigs = this._value._promotionBundleConfigs.concat();
    this._value._promotionBundleConfigs[index] = value;
    return this;
  }
  clearPromotionBundleConfigs_() {
    this._value._promotionBundleConfigs = [];
    return this;
  }
}
PromotionBundleConfigs.Builder = PromotionBundleConfigs_Builder;
class PromotionBundleConfigs_WithParent {
  /**
   * @param {PromotionBundleConfigs} value
   * @param {PromotionBundleConfigs_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PromotionBundleConfigs.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfPromotionBundleConfigs_() {
    if (!this._selfPromotionBundleConfigs_) {
      this._selfPromotionBundleConfigs_ = [];
      for (let i of this._value.promotionBundleConfigs) {
        this._selfPromotionBundleConfigs_.push(new PromotionBundleConfig.WithParent(i, null));
      }
    }
    return this._selfPromotionBundleConfigs_;
  }
  get inherentPromotionBundleConfigs_() {
    if (!this._inherentPromotionBundleConfigs_) {
      this._inherentPromotionBundleConfigs_ = this._parent ? this._parent.promotionBundleConfigs : [];
    }
    return this._inherentPromotionBundleConfigs_;
  }
  get promotionBundleConfigs() {
    if (!this._allPromotionBundleConfigs_) {
      this._allPromotionBundleConfigs_ = this._parent ? this._parent.promotionBundleConfigs.concat(this.selfPromotionBundleConfigs_) : this.selfPromotionBundleConfigs_;
    }
    return this._allPromotionBundleConfigs_;
  }
  update(current, parent) {
    const result = new PromotionBundleConfigs_WithParent(current, parent);
    if (this._selfPromotionBundleConfigs_) {
      if (this._value.promotionBundleConfigs === current.promotionBundleConfigs) {
        result._selfPromotionBundleConfigs_ = this._selfPromotionBundleConfigs_;
      } else {
        result._selfPromotionBundleConfigs_ = [];
        for (let i = 0; i < current.promotionBundleConfigs.length; i++) {
          const oldValue = this._value.promotionBundleConfigs[i];
          if (oldValue) {
            const oldCache = this._selfPromotionBundleConfigs_[i];
            if (oldValue === current.promotionBundleConfigs[i]) {
              result._selfPromotionBundleConfigs_[i] = oldCache;
            } else {
              result._selfPromotionBundleConfigs_[i] = oldCache.update(current.promotionBundleConfigs[i], null);
            }
          } else {
            result._selfPromotionBundleConfigs_[i] = new PromotionBundleConfig.WithParent(current.promotionBundleConfigs[i], null);
          }
        }
      }
    }
    return result;
  }
}
PromotionBundleConfigs_WithParent.default = new PromotionBundleConfigs_WithParent(PromotionBundleConfigs.default, null);
PromotionBundleConfigs.WithParent = PromotionBundleConfigs_WithParent;
class PromotionBundleConfigs_Descriptor {
  get promotionBundleConfigs() {
    if (!this._promotionBundleConfigs) {
      this._promotionBundleConfigs = {
        name: "promotionBundleConfigs",
        Name: "PromotionBundleConfigs_",
        number: 1,
        protoType: 11,
        protoName: "promotion_bundle_configs",
        type: PromotionBundleConfig,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._promotionBundleConfigs;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.promotionBundleConfigs,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
PromotionBundleConfigs.descriptor = new PromotionBundleConfigs_Descriptor();
